import React, { Component } from 'react';
import { Country, State, City } from 'country-state-city';
import { Container, Row, Col, Image, Form, Button, Modal, Nav, Spinner, ButtonGroup, Dropdown, Alert, Card, Tab, Tabs } from "react-bootstrap";
import { GiBodyHeight, GiMedicines } from "react-icons/gi";
import { FaHeartbeat, FaUserNurse, FaCalendarDay, FaArrowAltCircleLeft, FaArrowAltCircleRight, FaUser, FaEnvelope, FaPhoneAlt, FaCalendarAlt, FaChevronRight, FaChevronLeft, FaTransgender, FaList, FaUserMd, FaPlus, FaEllipsisV, FaWeight, FaHospital, FaBriefcaseMedical, FaSearch, FaGlobe, FaMapMarked, FaCity,FaInfoCircle, FaMicrophone } from "react-icons/fa";
import PatientRegistrationForm from './PatientRegistrationForm';

import { Multiselect } from 'multiselect-react-dropdown';
import C from '../lib/Config';
import Side from "./Sidebar";
import Top from "./Topbar";
import Calendar from 'react-calendar';
import { DatePicker } from 'antd';
import 'antd/dist/antd.css';
import Crypt from '../lib/Crypt';
import moment from 'moment';
import swal from 'sweetalert';
import MedicalStaffPreview from './MedicalStaffPreview';
import 'react-calendar/dist/Calendar.css';
import { Link } from 'react-router-dom';
import {Pagination, PaginationOpts, TableHeader, TableBody, Filter, useDatatableLifecycle, shouldTableUpdate} from 'react-bs-datatable';
import { CardHeader } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import Badge from '@material-ui/core/Badge';

const CustomTable = React.memo(props => {
    const {
          data, rowsPerPageOption, tableHeaders, onChangeFilter, onPageNavigate, classes, onRowsPerPageChange, onSortChange,
          tableClass, labels, filterable, filterText, rowsPerPage, currentPage, sortedProp, maxPage, Components
    } = useDatatableLifecycle(props);
  
    return (
      <div>
        <Components.Row className="controlRow__root">
          <Components.Col xs="12">
            <Filter
              classes={classes}
              tableHeaders={tableHeaders}
              placeholder='Search by Staff Name'
              onChangeFilter={onChangeFilter}
              filterText={filterText}
              filterable={filterable}
            />
          </Components.Col>
        </Components.Row>
        <Components.Row>
          <Components.Col xs="12">
            <Components.Table className={tableClass}>
              <TableHeader
                classes={classes}
                tableHeaders={tableHeaders}
                sortedProp={sortedProp}
                onSortChange={onSortChange}
                components={{
                  TableHead: Components.TableHead,
                  TableCell: Components.TableCell,
                  TableRow: Components.TableRow
                }}
              />
              <TableBody
                classes={classes}
                tableHeaders={tableHeaders}
                labels={labels}
                data={data}
                components={{
                  TableBody: Components.TableBody,
                  TableCell: Components.TableCell,
                  TableRow: Components.TableRow
                }}
              />
            </Components.Table>
          </Components.Col>
        </Components.Row>
        <Components.Row className="controlRow__root bottom">
          <Components.Col xs={12} md={12} className="text-right">
            <Pagination
              classes={classes}
              data={data}
              rowsPerPage={rowsPerPage}
              currentPage={currentPage}
              onPageNavigate={onPageNavigate}
              labels={labels}
              maxPage={maxPage}
              components={{ Button: Components.Button, ButtonGroup: Components.ButtonGroup }}
            />
          </Components.Col>
        </Components.Row>
      </div>
    );
  }, shouldTableUpdate);
const dateFormat = 'DD/MM/yyyy';
const customStyles = `
.input-group .form-control.is-invalid {
    border-color: #ced4da !important;
    background-image: none !important;
    padding-right: 0.75rem !important;
}

.input-group .form-control.is-invalid:focus {
    border-color: #ced4da !important;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
}

.invalid-feedback {
    display: block;
    margin-top: 0.25rem;
}
`;
export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.formBodyRef = React.createRef();   // DOM scope for voice writes
        this.state = {
            showGuidedVoice: false,   // guided voice intake overlay
            newCountryList: [],
            newStateList: [], 
            newCityList: [], 
            selectedNewCountry: {
                countryId: null,
                countryName: ""
            },
            selectedNewState: {
                stateId: null,
                stateName: ""
            },
            selectedNewCity: {
                cityId: null,
                cityCode: ""
            },
            showMRNSearch: false,
            // UI control flags
            isNewStateDropdownDisabled: true,
            isNewCityDropdownDisabled: true,

            // Validation errors specific to new fields
            newLocationErrors: {
                country: "",
                state: "",
                city: ""
            },
            ageYears: '',
            ageMonths: '',
            ageDays: '',
            isEditingAge: false,
            addEventModal: false,
            currentDateTime: Date().toLocaleString(),
            userdetail: {
                firstName: localStorage.getItem("firstName") ? localStorage.getItem("firstName") : "",
                lastName: localStorage.getItem("lastName") ? localStorage.getItem("lastName") : "",
                userRole: localStorage.getItem("userRoleDto") ? localStorage.getItem("userRoleDto") : "",
                profilePictureData: localStorage.getItem("profilePictureData") ? localStorage.getItem("profilePictureData") : "",
            },
            myActiveCaseCount: '',
            availableStaffCount: '',
            appointmentsCount: '',
            medicalStaffdata: [],
            previewModal: false,
            userId: localStorage.getItem("userId"),
            todaysAppointmentData: [],
            upcomingAppointmentData: [],
            isHospitalStaff: false,
            isLoaded: false,
            chemoDateDetails: {},
            fromPendingProfile: false,
            show: false,
            close: false,
            comorbiditiesArr: [],
            allergiesArr: [],
            anyOngoingTreatmentArr: [{ name: 'Yes', id: 1 }, { name: 'No', id: 2 }, { name: 'Not applicable', id: 3 }, { name: 'Prescribed but not taking', id: 4 }],
            instituteArr: [],
            weightArr: [],
            heightArr: [],
            medicineArr: [],
            genderArr: [],
            countryArr: [],
            isHospitalStaff: false,
            isAssociatedDocSelected: false,
            associatedDocList: [],
            registrationDate: null,
            firstName: '',
            middleName: '',
            lastName: '',
            emailId: '',
            dob: '',
            genderMstDto: { genderId: '' },
            countryDto: { countryId: null, countryCode: '',countryName:'' },
            phoneNumber1: '',
            doctor: { userId: '', firstName: '', lastName: '', username: '', roleName: '' },
            instituteDto: { instituteId: null, instituteName: '' },
            height: null, heightUnit: { unitId: null, unitName: '' },
            weight: null, weightUnit: { unitId: null, unitName: '' },
            patientComorbidities: [],
            patientAllergies: [],
            anyOngoingTreatment: null,
            patientComorbMed: [],
            patientRegErrors: {},
            activeCaseData: [],
            pendingCaseData: [],
            archivedCaseData: [],
            allCaseData: [],
            successAlertshow: false,
            successAlertForArchiveShow: false,
            successAlertclose: false,
            loaderModal: false,
            saveLoader: false,
            associatedDocList: [],
            allergies: '',
            otherComorbidities: '',
            isAllergiesSelected: false,
            errorAlertshow: false,
            errorAlertclose: false,
            checkDocInstAssociation : false,
            allAppointmentData: [],
            selectedDate: null,
            filteredAppointments: [],
            addressLine1:'',
            addressLine2:'',
            countryNameArr: [],
            countryId: '',
            countryName: '',
            pinCode: '',
            cityArr: [],
            stateArr: [],
            cityCode: '',
            stateName: '', 
            profilePictureName1: '',
            profilePictureData1: '',
            otherOngoingTreatment: '',
            isOngoingTreatmentSelected: false,
            isCommorbitiesSelected: false,



// Blood Group
     // Updated array formats to match your preferred style
     bloodGroupArr: ['Select Blood Group', 'A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-','Not known'],
     religionArr: ['Select Religion', 'Hinduism', 'Islam', 'Christianity', 'Sikhism', 'Buddhism', 'Jainism', 'Other'],
     educationArr: ['Select Education', 'No Formal Education', 'Primary', 'Secondary', 'Higher Secondary', 'Graduate', 'Post Graduate', 'Doctorate'],
     occupationArr: ['Select Occupation','Unskilled Labour', 'Skilled Labour',
                 'Services', 'Self Employee', 'Businessman', 
                  ' Professional'],
     maritalStatusArr: ['Select Marital Status', 'Single', 'Married', 'Divorced', 'Widowed'],
     idProofTypeArr: ['Select ID Proof Type', 'Aadhaar Card', 'PAN Card', 'Passport', 'Driving License', 'Voter ID'],
     relationArr: ['Select Relation', 
        'Father',
        'Mother', 
        'Spouse', 
        'Son', 
        'Daughter', 
        'Brother', 
        'Sister', 
        'Guardian', 
        'Friend', 
        'Other',
        'Daughter',
        'GrandFather',
        'GrandMother',
        'GrandSon',
        'GrandDaughter',
        'Uncle',
        'Aunt',
        'Nephew',
        'Niece',
        'Cousin'
        
],
     patientTypeArr: ['Select Patient Type', 'Inpatient', 'Outpatient', 'Emergency'],
     referralSourceArr: ['Select Referral Source', 'Self', 'Google', 'Social Media', 'word of Mouth', 'Physician/Doctor','Hospital'],
     selectedReferralSource: '',
  
  // Additional Information
   // Reset the new fields 
   bloodGroup: '',
   religion: '',
   education: '',
   occupation: '',
   maritalStatus: '',
   idProofType: '',
   idProofNumber: '',
   telephoneNumber: '',
   
   // Emergency Contact
   emergencyContactPerson: '',
   emergencyContactRelation: '',
   emergencyMobileType: '',
   emergencyMobileNumber: '',
   emergencyLandlineType: '',
   emergencyLandlineNumber: '',
   
   // Current Address
  
  currentCountryList: [],
  currentStateList: [],
  currentCityList: [],
  selectedCurrentCountry: {
      countryId: null,
      countryName: ""
  },
  selectedCurrentState: {
      stateId: null,
      stateName: ""
  },
  selectedCurrentCity: {
      cityId: null,
      cityCode: ""
  },
  isCurrentStateDropdownDisabled: true,
  isCurrentCityDropdownDisabled: true,
  sameAsPermanent: false,
   
   // Hospital Associated Details
   primaryConsultant: '',
   patientType: '',
   referralSource: '',
   referringPhysician: '',
   referringPhysicianNumber: '',
   referralDetails: '',    

 // Search terms for permanent address
 countrySearchTerm: '',
 stateSearchTerm: '',
 citySearchTerm: '',
 
 // Search terms for current address
 currentCountrySearchTerm: '',
 currentStateSearchTerm: '',
 currentCitySearchTerm: '',
 
 // Filtered lists for permanent address
 filteredCountryList: [],
 filteredStateList: [],
 filteredCityList: [],
 
 // Filtered lists for current address
 filteredCurrentCountryList: [],
 filteredCurrentStateList: [],
 filteredCurrentCityList: [],


            errors: {},
            category: '',
            company: '',
            tarrif: '',
            payType: '',
            status: '',
            mrnNumber: '',
        searchLoading: false,
        searchError: '',
        searchResult: null,
            isRestrictedFieldsVisible: false,
            categoryOptions: ['Select Category', 'Cash', 'Credit'],
            companyOptions: ['Select Company',
        'Cash Patient',
        'Insurance',
        'MJPJAY',
        'AB_ARKA',
        'AASA',
        'MDDSS',
        'YESIC',
        'ECHS',
        'MPKAY',
        'Trial (CRC)',
        'KCC Employee',
        'Insurance GIPSA PPN',
        'Private OPD',
        'Konkan Railway',
        'Airport',
        'KCC Package'],
            tarrifOptions: ['Select Tariff',
        'Cash Patient',
        'Insurance',
        'MJPJAY',
        'AB_ARKA',
        'AASA',
        'MDDSS',
        'YESIC',
        'ECHS',
        'MPKAY',
        'Trial (CRC)',
        'KCC Employee',
        'Insurance GIPSA PPN',
        'Private OPD',
        'Konkan Railway',
        'Airport',
        'KCC Package'],
            payTypeOptions: ['Select Pay Type', 'Cash', 'Credit'],
            statusOptions: ['Select Status', 'Status1', 'Status2', 'Status3']
        };
       this.handleNewCountryChange = this.handleNewCountryChange.bind(this);
        this.handleNewStateChange = this.handleNewStateChange.bind(this);
        this.handleNewCityChange = this.handleNewCityChange.bind(this);
        this.fetchNewCountries = this.fetchNewCountries.bind(this);
       this.fetchNewStates = this.fetchNewStates.bind(this);
        this.fetchNewCities = this.fetchNewCities.bind(this);
        this.setComorbidities = this.setComorbidities.bind(this);
       this.handleChange = this.handleChange.bind(this);
       this.profilePicHandler = this.profilePicHandler.bind(this);
       this.fileReaderHandler = this.fileReaderHandler.bind(this);
       this.fetchCurrentStates = this.fetchCurrentStates.bind(this);
       this.fetchCurrentCities = this.fetchCurrentCities.bind(this);
       this.handleCountrySearch = this.handleCountrySearch.bind(this);
       this.handleStateSearch = this.handleStateSearch.bind(this);
       this.handleCitySearch = this.handleCitySearch.bind(this);
       this.handleCurrentCountrySearch = this.handleCurrentCountrySearch.bind(this);
       this.handleCurrentStateSearch = this.handleCurrentStateSearch.bind(this);
       this.handleCurrentCitySearch = this.handleCurrentCitySearch.bind(this);
       this.handleSameAddressChange = this.handleSameAddressChange.bind(this);
       


       
    }
    componentDidMount () {


         // Add these to your initialization
    this.setState({
        isCountryDropdownOpen: false,
        isStateDropdownOpen: false,
        isCityDropdownOpen: false,
        isCurrentCountryDropdownOpen: false,
        isCurrentStateDropdownOpen: false,
        isCurrentCityDropdownOpen: false
    });

        this.getDashboardData();
        this.getAllAppointmentData();
        this.getCities();
        this.getStates();
        this.fetchNewCountries();
        this.getLoggedInUserDetails()
        this.handleMRNSearch();
        this.checkMRNAccess();
        
        }

        


        checkMRNAccess = () => {
            const userId = localStorage.getItem("userId");
            this.setState({ 
                showMRNSearch: userId === '92'
            });
        }


    // Update the getLoggedInUserDetails method
getLoggedInUserDetails = () => {
    const userId = localStorage.getItem("userId");
    const instituteId = this.state.instituteDto.instituteId;

    if (userId === '90' || instituteId === 30 || userId === '74' || instituteId === 22) {
        this.setState({ isRestrictedFieldsVisible: true });
    } else {
        this.setState({ isRestrictedFieldsVisible: false });
    }
}

// Fetch countries method
// Updated country fetch method using country-state-city library
fetchNewCountries() {
    const allCountries = Country.getAllCountries().map(country => ({
        id: country.isoCode, // or your API's expected format
        name: country.name
    }));
    
    this.setState({ 
        newCountryList: allCountries,
        filteredCountryList: allCountries,
        currentCountryList: allCountries,
        filteredCurrentCountryList: allCountries
    });
}

// Replace your state fetch method
fetchNewStates(countryId) {
    if (!countryId) {
        this.setState({
            newStateList: [],
            filteredStateList: [],
            isNewStateDropdownDisabled: true
        });
        return;
    }
    
    const countryStates = State.getStatesOfCountry(countryId).map(state => ({
        id: state.isoCode,
        name: state.name
    }));
    
    this.setState({
        newStateList: countryStates,
        filteredStateList: countryStates,
        isNewStateDropdownDisabled: countryStates.length === 0
    });
}
// Updated fetch cities method
fetchNewCities = async (stateId) => {
    try {
        const fullUrl = `${C.getUrl()}/patientLocation/getCitiesByState/${stateId}`;
        console.log("Fetching cities from URL:", fullUrl);

        const response = await fetch(fullUrl);
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const res = await response.json();
        
        // Handle different response formats
        let citiesData = [];

        if (Array.isArray(res)) {
            citiesData = res;
        } else if (res.message && typeof res.message === 'string') {
            try {
                citiesData = JSON.parse(res.message);
            } catch (parseError) {
                console.error("Error parsing cities message:", parseError);
            }
        } else if (res.message && Array.isArray(res.message)) {
            citiesData = res.message;
        } else if (res.data && Array.isArray(res.data)) {
            citiesData = res.data;
        }

        // Format the cities
        const formattedCities = citiesData.map(city => ({
            id: city.cityId || city.id,
            name: city.cityName || city.cityCode || city.name
        }));

        // Update state with both main and filtered lists
        this.setState({ 
            newCityList: formattedCities,
            filteredCityList: formattedCities,
            isNewCityDropdownDisabled: false,
            selectedNewCity: { cityId: null, cityCode: "" },
            // Reset search term when list changes
            citySearchTerm: ''
        });

        return formattedCities;
    } catch (error) {
        console.error("Complete cities fetch error details:", error);

        swal({ 
            title: "Error!", 
            text: `Failed to fetch cities: ${error.message}`, 
            icon: "error", 
            buttons: false, 
            timer: 3000 
        });

        this.setState({
            newCityList: [],
            filteredCityList: [],
            isNewCityDropdownDisabled: true,
            citySearchTerm: ''
        });

        return [];
    }
};

// Current address methods (similar to permanent address methods)

// Fetch countries for current address
fetchCurrentCountries = async () => {
    try {
        const response = await fetch(C.getUrl() + "/patientLocation/getAllCountries");
        const res = await response.json();
        
        // Log the entire response for debugging
        console.log("Current Countries Raw Response:", res);

        // Try different ways of extracting countries data
        let countriesData = [];
        
        if (res.message) {
            try {
                // Try to parse if message is a JSON string
                countriesData = typeof res.message === 'string' 
                    ? JSON.parse(res.message) 
                    : res.message;
            } catch (parseError) {
                console.error("Error parsing countries message:", parseError);
            }
        } else if (Array.isArray(res)) {
            countriesData = res;
        }

        // Ensure we have an array
        if (!Array.isArray(countriesData)) {
            console.error("Expected array but got:", typeof countriesData, countriesData);
            countriesData = [];
        }

        // Format the countries to match existing structure
        const formattedCountries = countriesData.map(country => ({
            id: country.countryId || country.id,
            name: country.countryName || country.name,
            code: country.countryCode || country.code
        }));

        console.log("Formatted Current Countries:", formattedCountries);

        // Update state with the formatted data
        this.setState({ 
            currentCountryList: formattedCountries
        });
    } catch (error) {
        console.error("Error fetching current countries:", error);
        swal({ 
            title: "Error!", 
            text: "Failed to fetch countries", 
            icon: "error", 
            buttons: false, 
            timer: 2000 
        });
    }
};
// Replace your current address state fetch
fetchCurrentStates(countryId) {
    if (!countryId) {
        this.setState({
            currentStateList: [],
            filteredCurrentStateList: [],
            isCurrentStateDropdownDisabled: true
        });
        return;
    }
    
    const countryStates = State.getStatesOfCountry(countryId).map(state => ({
        id: state.isoCode,
        name: state.name
    }));
    
    this.setState({
        currentStateList: countryStates,
        filteredCurrentStateList: countryStates,
        isCurrentStateDropdownDisabled: countryStates.length === 0
    });
}
// Replace your city fetch method
fetchNewCities(countryId, stateId) {
    if (!countryId || !stateId) {
        this.setState({
            newCityList: [],
            filteredCityList: [],
            isNewCityDropdownDisabled: true
        });
        return;
    }
    
    const stateCities = City.getCitiesOfState(countryId, stateId).map(city => ({
        id: city.name, // Use a unique identifier
        name: city.name
    }));
    
    this.setState({
        newCityList: stateCities,
        filteredCityList: stateCities,
        isNewCityDropdownDisabled: stateCities.length === 0
    });
}

// Replace your current address city fetch
fetchCurrentCities(countryId, stateId) {
    if (!countryId || !stateId) {
        this.setState({
            currentCityList: [],
            filteredCurrentCityList: [],
            isCurrentCityDropdownDisabled: true
        });
        return;
    }
    
    const stateCities = City.getCitiesOfState(countryId, stateId).map(city => ({
        id: city.name, // Use a unique identifier
        name: city.name
    }));
    
    this.setState({
        currentCityList: stateCities,
        filteredCurrentCityList: stateCities,
        isCurrentCityDropdownDisabled: stateCities.length === 0
    });
}

// Add these search handlers for current address
handleCurrentCountrySearch(e) {
    const searchTerm = e.target.value;
    const filteredCountries = this.state.currentCountryList.filter(country => 
        country.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    this.setState({
        currentCountrySearchTerm: searchTerm,
        filteredCurrentCountryList: filteredCountries
    });
}

handleCurrentStateSearch(e) {
    const searchTerm = e.target.value;
    const filteredStates = this.state.currentStateList.filter(state => 
        state.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    this.setState({
        currentStateSearchTerm: searchTerm,
        filteredCurrentStateList: filteredStates
    });
}

handleCurrentCitySearch(e) {
    const searchTerm = e.target.value;
    const filteredCities = this.state.currentCityList.filter(city => 
        city.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    this.setState({
        currentCitySearchTerm: searchTerm,
        filteredCurrentCityList: filteredCities
    });
}
// Add these search handlers for permanent address
handleCountrySearch(e) {
    const searchTerm = e.target.value;
    const filteredCountries = this.state.newCountryList.filter(country => 
        country.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    this.setState({
        countrySearchTerm: searchTerm,
        filteredCountryList: filteredCountries
    });
}

handleStateSearch(e) {
    const searchTerm = e.target.value;
    const filteredStates = this.state.newStateList.filter(state => 
        state.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    this.setState({
        stateSearchTerm: searchTerm,
        filteredStateList: filteredStates
    });
}

handleCitySearch(e) {
    const searchTerm = e.target.value;
    const filteredCities = this.state.newCityList.filter(city => 
        city.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    this.setState({
        citySearchTerm: searchTerm,
        filteredCityList: filteredCities
    });
}

// Update your country change handler
handleNewCountryChange(e) {
    const countryId = e.target.value;
    
    if (countryId === "") {
        this.setState({
            selectedNewCountry: { countryId: null, countryName: "" },
            selectedNewState: { stateId: null, stateName: "" },
            selectedNewCity: { cityId: null, cityCode: "" },
            stateSearchTerm: "",
            citySearchTerm: ""
        });
    } else {
        const selectedCountry = this.state.newCountryList.find(country => country.id === countryId);
        
        this.setState({
            selectedNewCountry: { 
                countryId: selectedCountry.id, 
                countryName: selectedCountry.name 
            }
        });
    }
    
    // Fetch states for the selected country
    this.fetchNewStates(countryId);
    
    // Reset city data
    this.setState({
        selectedNewCity: { cityId: null, cityCode: "" },
        newCityList: [],
        filteredCityList: [],
        isNewCityDropdownDisabled: true
    });
}

// Fix for the current address state and city display issues
handleCurrentCountryChange = (e) => {
    const countryId = e.target.value;
    
    if (countryId === "") {
        this.setState({
            selectedCurrentCountry: { countryId: null, countryName: "" },
            selectedCurrentState: { stateId: null, stateName: "" },
            selectedCurrentCity: { cityId: null, cityCode: "" },
            currentStateSearchTerm: "",
            currentCitySearchTerm: "",
            isCurrentStateDropdownDisabled: true,
            isCurrentCityDropdownDisabled: true,
            currentStateList: [],
            filteredCurrentStateList: [],
            currentCityList: [],
            filteredCurrentCityList: []
        });
    } else {
        const selectedCountry = this.state.currentCountryList.find(country => country.id === countryId);
        
        // Get states for the selected country
        const countryStates = State.getStatesOfCountry(countryId).map(state => ({
            id: state.isoCode,
            name: state.name
        }));
        
        this.setState({
            selectedCurrentCountry: { 
                countryId: selectedCountry.id, 
                countryName: selectedCountry.name 
            },
            currentStateList: countryStates,
            filteredCurrentStateList: countryStates,
            selectedCurrentState: { stateId: null, stateName: "" },
            selectedCurrentCity: { cityId: null, cityCode: "" },
            isCurrentStateDropdownDisabled: countryStates.length === 0,
            isCurrentCityDropdownDisabled: true,
            currentCityList: [],
            filteredCurrentCityList: []
        });
    }
}



// Fix for the permanent address city display issue
handleNewStateChange = (e) => {
    const stateId = e.target.value;
    
    if (stateId === "") {
        this.setState({
            selectedNewState: { stateId: null, stateName: "" },
            selectedNewCity: { cityId: null, cityCode: "" },
            citySearchTerm: "",
            isNewCityDropdownDisabled: true,
            newCityList: [],
            filteredCityList: []
        });
    } else {
        const selectedState = this.state.newStateList.find(state => state.id === stateId);
        
        // Get cities for the selected country and state
        const stateCities = City.getCitiesOfState(
            this.state.selectedNewCountry.countryId, 
            stateId
        ).map(city => ({
            id: city.name, // Using name as ID since cities don't have ISO codes
            name: city.name
        }));
        
        this.setState({
            selectedNewState: { 
                stateId: selectedState.id, 
                stateName: selectedState.name 
            },
            newCityList: stateCities,
            filteredCityList: stateCities,
            isNewCityDropdownDisabled: stateCities.length === 0
        });
    }
}

// Add a missing handler for Current State change
handleCurrentStateChange = (e) => {
    const stateId = e.target.value;
    
    if (stateId === "") {
        this.setState({
            selectedCurrentState: { stateId: null, stateName: "" },
            selectedCurrentCity: { cityId: null, cityCode: "" },
            currentCitySearchTerm: "",
            isCurrentCityDropdownDisabled: true,
            currentCityList: [],
            filteredCurrentCityList: []
        });
    } else {
        const selectedState = this.state.currentStateList.find(state => state.id === stateId);
        
        // Get cities for the selected country and state
        const stateCities = City.getCitiesOfState(
            this.state.selectedCurrentCountry.countryId, 
            stateId
        ).map(city => ({
            id: city.name, // Using name as ID since cities don't have ISO codes
            name: city.name
        }));
        
        this.setState({
            selectedCurrentState: { 
                stateId: selectedState.id, 
                stateName: selectedState.name 
            },
            currentCityList: stateCities,
            filteredCurrentCityList: stateCities,
            isCurrentCityDropdownDisabled: stateCities.length === 0
        });
    }
}

// Update your city change handler
handleNewCityChange(e) {
    const cityId = e.target.value;
    
    if (cityId === "") {
        this.setState({
            selectedNewCity: { cityId: null, cityCode: "" }
        });
    } else {
        const selectedCity = this.state.newCityList.find(city => city.id === cityId);
        
        this.setState({
            selectedNewCity: { 
                cityId: selectedCity.id, 
                cityCode: selectedCity.name  // Adjust based on your data structure
            }
        });
    }
}


// Add a missing handler for Current City change
handleCurrentCityChange = (e) => {
    const cityId = e.target.value;
    
    if (cityId === "") {
        this.setState({
            selectedCurrentCity: { cityId: null, cityCode: "" }
        });
    } else {
        const selectedCity = this.state.currentCityList.find(city => city.id === cityId);
        
        this.setState({
            selectedCurrentCity: { 
                cityId: selectedCity.id, 
                cityCode: selectedCity.name
            }
        });
    }
}


    // fetchNewCountries = async () => {
    //     try {
    //         const response = await fetch(C.getUrl() + '/countryMaster/getallCountries');
    //         const res = await response.json();
    //         const data = JSON.parse(res.message);
            
    //         const formattedCountries = data.map(country => ({
    //             id: country.countryId,
    //             name: country.countryName,
    //             code: country.countryCode
    //         }));
    
    //         this.setState({ newCountryList: formattedCountries });
    //     } catch (error) {
    //         console.error("Error fetching countries:", error);
    //         swal({ 
    //             title: "Error!", 
    //             text: "Failed to fetch countries", 
    //             icon: "error", 
    //             buttons: false, 
    //             timer: 2000 
    //         });
    //     }
    // };
    
    // // Fetch states based on selected country
    // fetchNewStates = async (countryId) => {
    //     try {
    //         const response = await fetch(C.getUrl() + `/countryMaster/getCountryById/${countryId}`);
    //         const res = await response.json();
    //         const data = JSON.parse(res.message);
            
    //         if (data.stateMasterDTOList) {
    //             const formattedStates = data.stateMasterDTOList.map(state => ({
    //                 id: state.stateId,
    //                 name: state.stateName,
    //                 cityList: state.cityList || []
    //             }));
    
    //             this.setState({ 
    //                 newStateList: formattedStates,
    //                 isNewStateDropdownDisabled: false,
    //                 selectedNewState: { stateId: null, stateName: "" },
    //                 selectedNewCity: { cityId: null, cityCode: "" },
    //                 isNewCityDropdownDisabled: true,
    //                 newCityList: []
    //             });
    //         }
    //     } catch (error) {
    //         console.error("Error fetching states:", error);
    //         swal({ 
    //             title: "Error!", 
    //             text: "Failed to fetch states", 
    //             icon: "error", 
    //             buttons: false, 
    //             timer: 2000 
    //         });
    //     }
    // };
    
    // // Process cities from state data
    // fetchNewCities = (stateId) => {
    //     const selectedState = this.state.newStateList.find(state => state.id === parseInt(stateId));
        
    //     if (selectedState && selectedState.cityList) {
    //         const formattedCities = selectedState.cityList.map(city => ({
    //             id: city.cityId,
    //             name: city.cityCode
    //         }));
    
    //         this.setState({ 
    //             newCityList: formattedCities,
    //             isNewCityDropdownDisabled: false,
    //             selectedNewCity: { cityId: null, cityCode: "" }
    //         });
    //     }
    // };
    
    // Add these new methods for handling changes
    
    // handleNewCountryChange = (event) => {
    //     const countryId = event.target.value;
    //     const selectedCountry = this.state.newCountryList.find(country => country.id === parseInt(countryId));
        
    //     this.setState({
    //         selectedNewCountry: {
    //             countryId: selectedCountry.id,
    //             countryName: selectedCountry.name
    //         },
    //         newLocationErrors: {
    //             ...this.state.newLocationErrors,
    //             country: ""
    //         }
    //     });
    
    //     this.fetchNewStates(countryId);
    // };
    
    // handleNewStateChange = (event) => {
    //     const stateId = event.target.value;
    //     const selectedState = this.state.newStateList.find(state => state.id === parseInt(stateId));
        
    //     this.setState({
    //         selectedNewState: {
    //             stateId: selectedState.id,
    //             stateName: selectedState.name
    //         },
    //         newLocationErrors: {
    //             ...this.state.newLocationErrors,
    //             state: ""
    //         }
    //     });
    
    //     this.fetchNewCities(stateId);
    // };
    
    // handleNewCityChange = (event) => {
    //     const cityId = event.target.value;
    //     const selectedCity = this.state.newCityList.find(city => city.id === parseInt(cityId));
        
    //     this.setState({
    //         selectedNewCity: {
    //             cityId: selectedCity.id,
    //             cityCode: selectedCity.name
    //         },
    //         newLocationErrors: {
    //             ...this.state.newLocationErrors,
    //             city: ""
    //         }
    //     });
    // };
    // Add this new validation method
    validateNewLocationFields = () => {
        let isValid = true;
        const newErrors = {
            country: "",
            state: "",
            city: ""
        };
    
        if (!this.state.selectedNewCountry.countryId) {
            newErrors.country = "Please select a country";
            isValid = false;
        }
    
        if (!this.state.selectedNewState.stateId && !this.state.isNewStateDropdownDisabled) {
            newErrors.state = "Please select a state";
            isValid = false;
        }
    
        if (!this.state.selectedNewCity.cityId && !this.state.isNewCityDropdownDisabled) {
            newErrors.city = "Please select a city";
            isValid = false;
        }
    
        this.setState({ newLocationErrors: newErrors });
        return isValid;
    };
    getAssociatedDocList = async () => {
        let userId = localStorage.getItem('userId');
        return fetch(C.getUrl() + `/user/getUserByUserId/${userId}`)
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let msg = resObj.message
                let data = JSON.parse(msg);
                let doc = data.associatedDoctorDTOList;
                var arr = [];
                doc.map((item, i) => {
                    arr.push({
                        key: Crypt.getUniqueKey(i),
                        id: item.userId,
                        name: `${item.firstName} ${item.lastName}`,
                        firstName: item.firstName,
                        lastName: item.lastName
                    });
                });
                this.setState({ associatedDocList: arr });
                //console.table(arr);
            })
            .catch(err => {
                //console.log("Error : " + err);
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }
    getallCountries() {
        return fetch(C.getUrl() + '/countryMaster/getallCountries')
            .then(res => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then(resObj => {
                let msg = resObj.message
                let data = JSON.parse(msg);
                var arr = [];
                var countryNameArr = [];
                data.map(function (d) {
                    arr.push({ id: d.countryId, name: d.countryCode + ' ' + d.phoneContryCode });
                    countryNameArr.push({ id: d.countryId, name: d.countryName });
                });
                this.setState({ countryArr: arr });
                //console.log("countryArr : " + JSON.stringify(this.state.countryArr));
                this.setState({ countryArr: arr,countryNameArr: countryNameArr });
                console.log("countryArr : " + JSON.stringify(this.state.countryArr));
                
            })
            .catch(err => {
                console.error("Error fetching countries: " + err);
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    getAllGender() {
        return fetch(C.getUrl() + '/genderMaster/getAllGenders')
            .then(res => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then(resObj => {
                let msg = resObj.message
                let data = JSON.parse(msg);
                var arr = [];
                data.map(function (d) {
                    arr.push({ id: d.genderId, name: d.genderName });
                });
                this.setState({ genderArr: arr });
                //console.log("genderArr : " + JSON.stringify(this.state.genderArr));
            })
            .catch(err => {
                console.error("Error fetching genders: " + err);
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    getAllMedicines() {
        return fetch(C.getUrl() + '/medicineMst/getAllMedicines')
            .then(res => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then(resObj => {
                let arr = [];
                // Handle different response formats
                let medicinesData = resObj;
                
                // If response has a message property (JSON string), parse it
                if (resObj.message && typeof resObj.message === 'string') {
                    try {
                        medicinesData = JSON.parse(resObj.message);
                    } catch (e) {
                        console.error("Error parsing medicines message:", e);
                        medicinesData = [];
                    }
                } else if (resObj.message && Array.isArray(resObj.message)) {
                    medicinesData = resObj.message;
                }
                
                // Ensure we have an array
                if (Array.isArray(medicinesData)) {
                    medicinesData.map(function (d) {
                        arr.push({ id: d.medicineId, name: d.medicineName });
                    });
                }
                
                this.setState({ medicineArr: arr });
                console.log("medicineArr : " + JSON.stringify(arr));
            })
            .catch(err => {
                console.error("Error fetching medicines: " + err);
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    getAllUnits() {
        return fetch(C.getUrl() + '/unitMst/getAllUnits')
            .then(res => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then(resObj => {
                var ht = [];
                var wt = [];
                
                // Handle different response formats
                let unitsData = resObj;
                if (resObj.message && typeof resObj.message === 'string') {
                    try {
                        unitsData = JSON.parse(resObj.message);
                    } catch (e) {
                        console.error("Error parsing units message:", e);
                        unitsData = [];
                    }
                } else if (resObj.message && Array.isArray(resObj.message)) {
                    unitsData = resObj.message;
                }
                
                // Process units array
                if (Array.isArray(unitsData)) {
                    unitsData.map((item, index) => {
                        if (item.unitCategory === 'wt') {
                            wt.push({ id: item.unitId, name: item.unitName });
                            if(item.unitName==='KG' || item.unitName==='kg'){
                                this.setState({ weightUnit: { unitId: item.unitId } });
                            }
                        }
                        if (item.unitCategory === 'len') {
                            ht.push({ id: item.unitId, name: item.unitName });
                            if(item.unitName==='cm' || item.unitName==='CM'){
                                this.setState({ heightUnit: { unitId: item.unitId } });
                            }
                        }
                    })
                }
                this.setState({ weightArr: wt, heightArr: ht });
            })
            .catch(err => {
                console.error("Error fetching units: " + err);
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    getAllAllergies() {
        return fetch(C.getUrl() + '/allergies/getAllAlergies')
            .then(res => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then(resObj => {
                var arr = [];
                
                // Handle different response formats
                let allergiesData = resObj;
                if (resObj.message && typeof resObj.message === 'string') {
                    try {
                        allergiesData = JSON.parse(resObj.message);
                    } catch (e) {
                        console.error("Error parsing allergies message:", e);
                        allergiesData = [];
                    }
                } else if (resObj.message && Array.isArray(resObj.message)) {
                    allergiesData = resObj.message;
                }
                
                // Process allergies array
                if (Array.isArray(allergiesData)) {
                    allergiesData.map(function (d) {
                        arr.push({ id: d.allergiesId, name: d.allergiesName });
                    });
                }
                
                this.setState({ allergiesArr: arr });
                console.log("allergiesArr : " + JSON.stringify(arr));
            })
            .catch(err => {
                console.error("Error fetching allergies: " + err);
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

// MRN number

handleMRNChange = (e) => {
    // Allow only numbers
    const value = e.target.value.replace(/\D/g, '');
    this.setState({ 
        mrnNumber: value,
        searchError: ''
    });
}


handleMRNPatientRegistration = (patientData) => {
    // Map gender values
    const genderMapping = {
        'Female': '2',
        'Male': '1',
        'Other': '3'
    };

    // Format date from "1960-09-03" to "2025-01-22T07:54:54.869Z" format
    const formatDate = (dateString) => {
        if (!dateString) return null;
        return new Date(dateString).toISOString();
    };

    // Get salutation from patient_name
    let salutation = '';
    if (patientData.patient_name) {
        const match = patientData.patient_name.match(/(Mr\.|Mrs\.|Ms\.|Dr\.)/);
        salutation = match ? match[0] : '';
    }

    // Create patient registration object
    const patientRegistrationObj = {
        // Map direct fields from GET API including salutation and blood group
        salutation: salutation, // Add salutation from parsed patient_name
        firstName: patientData.patient_name ? patientData.patient_name.replace(/(Mr\.|Mrs\.|Ms\.|Dr\.)/, '').trim() : '',
        lastName: patientData.surname || '',
        addressLine1: patientData.address1 || '',
        addressLine2: patientData.address2 || '',
        addressLine3: patientData.address3 || '',
        pinCode: patientData.pincode || '',
        cityCode: patientData.city || '',
        dob: formatDate(patientData.birth_date),
        phoneNumber1: patientData.mobile || '',
        mrNo: patientData.mrn || '',
        maritalStatus: patientData.marital_status || '',
        bloodGroup: patientData.blood_group || '', // Add blood group directly from API response

        // Map gender
        genderMstDto: {
            genderId: genderMapping[patientData.sex] || '3'
        },

        // Default required fields remain the same
        emailId: 'test@gmail.com',
        countryDto: {
            countryId: "1"
        },
        doctor: {
            userId: 92,
            firstName: "Thangam ",
            lastName: "Institude ",
            username: '',
            userRoleDto: {
                roleName: "Doctor"
            }
        },
        instituteDto: {
            instituteId: "34"
        },
        height: 180,
        heightUnitDto: {
            unitId: 1
        },
        weight: 54,
        weightUnitDto: {
            unitId: 4
        },
        patientComorbidities: [],
        patientAllergies: [],
        onGoingTreatment: null,
        otherOngoingTreatment: '',
        patientComorbiditiesMedicines: [],
        allergies: '',
        otherComorbidities: '',
        profilePictureName: '',
        profilePictureData: ''
    };

    return fetch(C.getUrl() + '/userCase/registerPatient', {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(patientRegistrationObj),
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(res => res.json())
    .then(res => {
        let obj = res;
        let error = obj.subErrors;
        if (error !== null && error !== "") {
            throw new Error(error);
        }
        return true;
    });
};

handleMRNSearch = async () => {
    const { mrnNumber, showMRNSearch } = this.state;

    if (!showMRNSearch) {
        return;
    }

    if (!mrnNumber) {
        this.setState({ searchError: 'Please enter MRN number' });
        return;
    }

    this.setState({ searchLoading: true });

    try {
        const response = await fetch(
            `http://103.168.199.187:93/rasterihmsapi/ihmsctrl.php?getPatientInfo&mrn=${mrnNumber}`
        );

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const result = await response.json();

        if (result.data && result.data.length > 0) {
            const patientData = result.data[0];
            
            // Register patient with GET API data
            await this.handleMRNPatientRegistration(patientData);
            
            swal({
                title: "Success!",
                text: "Patient registered successfully",
                icon: "success",
                buttons: false,
                timer: 2000
            });

            // Reload page after successful registration
            window.location.reload(false);

        } else {
            throw new Error('No patient data found');
        }

    } catch (err) {
        console.error('Error:', err);
        this.setState({ 
            searchError: err.message || 'Failed to process patient information'
        });
        
        swal({
            title: "Error!",
            text: err.message || "Failed to process patient information",
            icon: "error",
            buttons: false,
            timer: 2000
        });
    } finally {
        this.setState({ searchLoading: false });
    }
};

    getAllComorbidites() {
        return fetch(C.getUrl() + '/comorbidities/getAllcomorbidities')
            .then(res => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then(resObj => {
                var arr = [];
                
                // Handle different response formats
                let comorbiditiesData = resObj;
                if (resObj.message && typeof resObj.message === 'string') {
                    try {
                        comorbiditiesData = JSON.parse(resObj.message);
                    } catch (e) {
                        console.error("Error parsing comorbidities message:", e);
                        comorbiditiesData = [];
                    }
                } else if (resObj.message && Array.isArray(resObj.message)) {
                    comorbiditiesData = resObj.message;
                }
                
                // Process comorbidities array
                if (Array.isArray(comorbiditiesData)) {
                    comorbiditiesData.map(function (d) {
                        arr.push({ id: d.comorbiditiesId, name: d.comorbiditiesName });
                    });
                }
                
                this.setState({ comorbiditiesArr: arr });
                console.log("comorbiditiesArr : " + JSON.stringify(arr));
            })
            .catch(err => {
                console.error("Error fetching comorbidities: " + err);
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    getAllInstitute() {
        let userId = localStorage.getItem('userId');
        console.log("userId : " + userId);
        return fetch(C.getUrl() + '/institute/getAllInstituteByUserId/'+userId)
            .then(res => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then(resObj => {
                console.log("instituteArr : " + JSON.stringify(this.state.instituteArr));
                if (!Array.isArray(resObj)) return;
                var arr = [];
                resObj.map(function (d) {
                    arr.push({ id: d.instituteId, name: d.instituteName });
                });
                this.setState({ instituteArr: arr });
                console.log("instituteArr : " + JSON.stringify(this.state.instituteArr));
            })
            .catch(err => {
                console.error("Error fetching user institutes: " + err);
            });
    }

    getAllInstituteAssociated(docId) {
        return fetch(C.getUrl() + '/institute/getAllInstituteByUserId/'+docId)
            .then(res => res.json())
            .then(res => {
                if (!Array.isArray(res)) return;
                var arr = [];
                res.map(function (d) {
                    arr.push({ id: d.instituteId, name: d.instituteName });
                });
                this.setState({ instituteArr: arr });
                //console.log("instituteArr : " + JSON.stringify(this.state.instituteArr));
            })
            .catch(err => {
                console.error("Error fetching associated institutes: " + err);
            });
    }

    getAssociatedDocList = async () => {
        let userId = localStorage.getItem('userId');
        return fetch(C.getUrl() + `/user/getUserByUserId/${userId}`)
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let msg = resObj.message
                let data = JSON.parse(msg);
                let doc = data.associatedDoctorDTOList;
                var arr = [];
                doc.map((item, i) => {
                    arr.push({
                        key: Crypt.getUniqueKey(i),
                        id: item.userId,
                        name: `${item.firstName} ${item.lastName}`,
                        firstName: item.firstName,
                        lastName: item.lastName
                    });
                });
                this.setState({ associatedDocList: arr });
                //console.table(arr);
            })
            .catch(err => {
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    getTodayDate() {
        return new Date().toJSON().slice(0, 10).split('-').reverse().join('/');
    }

    handleChange(event) {
        const { associatedDocList } = this.state;
        if (event.target.name === 'registrationDate') {
            this.setState({ registrationDate: event.target.value });
        }
        if (event.target.name === 'firstName') {
            this.setState({ firstName: event.target.value });
        }
        if (event.target.name === 'middleName') {
            this.setState({ middleName: event.target.value });
        }
        if (event.target.name === 'lastName') {
            this.setState({ lastName: event.target.value });
        }
        if (event.target.name === 'email') {
            this.setState({ emailId: event.target.value });
        }if (event.target.name === 'addressline1') {
            this.setState({ addressLine1: event.target.value });
        }
        if (event.target.name === 'addressline2') {
            this.setState({ addressLine2: event.target.value });
        }
        if (event.target.name === 'pinCode') {
            this.setState({ pinCode: event.target.value });
        }
        if (event.target.name === 'cityCode') {
            this.setState({ cityCode: event.target.value });
        }
        if (event.target.name === 'phoneNumber1') {
            this.setState({ phoneNumber1: event.target.value });
        }
        if (event.target.name === 'pinCode') {
            const regex = /^[0-9\b]+$/; 
            if (event.target.value === '' || (regex.test(event.target.value) && event.target.value.length <= 10)) {
                this.setState({ pinCode: event.target.value });
            }
            return;
        }
        if (event.target.name === 'stateName') {
            this.setState({ stateName: event.target.value });
        }
        if (event.target.name === 'dob') {
            this.setState({ dob: event.target.value });
        }
        if (event.target.name === 'weight') {
            this.setState({ weight: event.target.value });
        }
        if (event.target.name === 'weightUnit') {
            this.setState({ weightUnit: { unitId: event.target.value } });
        }
        if (event.target.name === 'height') {
            this.setState({ height: event.target.value });
        }
        if (event.target.name === 'heightUnit') {
            this.setState({ heightUnit: { unitId: event.target.value } });
        }
        if (event.target.name === 'gender') {
            console.log(JSON.stringify(event.target.value))
            this.setState({ genderMstDto: { genderId: event.target.value } });
        }
        if (event.target.name === 'institute') {
            this.setState({ instituteDto: { instituteId: event.target.value } });
        }
        if (event.target.name === 'country') {
            this.setState({ countryDto: { countryId: event.target.value } });
        }
        if (event.target.name === 'countryName') {
            this.setState({ countryName: event.target.value });
        }
        if (event.target.name === 'category') {
            this.setState({ category: event.target.value });
        }
        if (event.target.name === 'company') {
            this.setState({ company: event.target.value });
        }
        if (event.target.name === 'tarrif') {
            this.setState({ tarrif: event.target.value });
        }
        if (event.target.name === 'payType') {
            this.setState({ payType: event.target.value });
        }
        if (event.target.name === 'status') {
            this.setState({ status: event.target.value });
        }
        if (event.target.name === 'anyOngoingTreatment') {
            const selectedOption = this.state.anyOngoingTreatmentArr.find((option) => option.id == event.target.value);
            const isYesSelected = selectedOption && selectedOption.name === 'Yes';
      
            this.setState({
              anyOngoingTreatment: selectedOption ? selectedOption.name : '',
              isOngoingTreatmentSelected: isYesSelected,
              otherOngoingTreatment: isYesSelected ? this.state.otherOngoingTreatment : '' 
            });
          }
      
          if (event.target.name === 'otherOngoingTreatment') {
            this.setState({ otherOngoingTreatment: event.target.value });
          }
        if (event.target.name === 'comorbiditiesMedicine') {
            this.setState({ patientComorbMed: event.target.value });
        }
        if (event.target.name === 'docList') {
            associatedDocList.map((item, i) => {
                if (event.target.value === item.id + '') {
                    this.setSelectedDocData(item)
                }
            });
        }
        if (event.target.name === 'allergies') {
            this.setState({ allergies: event.target.value });
        }
        if (event.target.name === 'otherComorbidities') {
            this.setState({ otherComorbidities: event.target.value });
        }

         // Add this to handle referralDetails
         if (event.target.name === 'referralDetails') {
            this.setState({ referralDetails: event.target.value });
        }
    
    // Make sure the referringHospital is properly handled
    if (event.target.name === 'referringHospital') {
        this.setState({ referringHospital: event.target.value });
    }

     // Blood Group
if (event.target.name === 'bloodGroup') {
    this.setState({ bloodGroup: event.target.value });
}

// Religion, Education, Occupation
if (event.target.name === 'religion') {
    this.setState({ religion: event.target.value });
}
if (event.target.name === 'education') {
    this.setState({ education: event.target.value });
}
if (event.target.name === 'occupation') {
    this.setState({ occupation: event.target.value });
}
if (event.target.name === 'maritalStatus') {
    this.setState({ maritalStatus: event.target.value });
}

// ID Proof
if (event.target.name === 'idProofType') {
    this.setState({ idProofType: event.target.value });
}
if (event.target.name === 'idProofNumber') {
    this.setState({ idProofNumber: event.target.value });
}

// Emergency Contact
if (event.target.name === 'emergencyContactPerson') {
    this.setState({ emergencyContactPerson: event.target.value });
}
if (event.target.name === 'emergencyContactRelation') {
    this.setState({ emergencyContactRelation: event.target.value });
}
if (event.target.name === 'emergencyMobileType') {
    this.setState({ emergencyMobileType: event.target.value });
}
if (event.target.name === 'emergencyMobileNumber') {
    this.setState({ emergencyMobileNumber: event.target.value });
}
if (event.target.name === 'emergencyLandlineType') {
    this.setState({ emergencyLandlineType: event.target.value });
}
if (event.target.name === 'emergencyLandlineNumber') {
    this.setState({ emergencyLandlineNumber: event.target.value });
}

// Current Address
if (event.target.name === 'currentAddressLine1') {
    this.setState({ currentAddressLine1: event.target.value });
}
if (event.target.name === 'currentAddressLine2') {
    this.setState({ currentAddressLine2: event.target.value });
}
if (event.target.name === 'currentCountry') {
    this.setState({ currentCountry: event.target.value });
}
if (event.target.name === 'currentState') {
    this.setState({ currentState: event.target.value });
}
if (event.target.name === 'currentCity') {
    this.setState({ currentCity: event.target.value });
}
if (event.target.name === 'currentPinCode') {
    this.setState({ currentPinCode: event.target.value });
}

// Hospital Associated Details
if (event.target.name === 'primaryConsultant') {
    this.setState({ primaryConsultant: event.target.value });
}
if (event.target.name === 'patientType') {
    this.setState({ patientType: event.target.value });
}
if (event.target.name === 'referralSource') {
    this.setState({ referralSource: event.target.value });
}
if (event.target.name === 'telephoneNumber') {
    this.setState({ telephoneNumber: event.target.value });
}
// Referral Details (if missing)
if (event.target.name === 'referringPhysician') {
    this.setState({ referringPhysician: event.target.value });
}
if (event.target.name === 'referringPhysicianNumber') {
    this.setState({ referringPhysicianNumber: event.target.value });

}
    }

    nextButtonHandler = () => {
        if (this.validateGeneralInfo()) {
            const nextTab = document.getElementById("nextTab");
            const currentTab = document.getElementById("nextTab1");
            
            if (nextTab && currentTab) {
                nextTab.style.display = "block";
                currentTab.style.display = "none";
                nextTab.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }
    
    previousButtonHandler = () => {
        const nextTab = document.getElementById("nextTab");
        const currentTab = document.getElementById("nextTab1");
        
        if (nextTab && currentTab) {
            nextTab.style.display = "none";
            currentTab.style.display = "block";
            currentTab.scrollIntoView({ behavior: 'smooth' });
        }
    }
    validateGeneralInfo = () => {
        let formIsValid = true;
        let errors = {};
        if (this.state.doctor === "" || this.state.doctor === null ||
            this.state.doctor.userId === null || this.state.doctor.userId === 0) {
            console.log("Doctor " + this.state.doctor.userId);
            errors["doctor"] = "Doctor's name not specified";
            formIsValid = false;
        }
        if (this.state.firstName === "" || this.state.firstName == null) {
            errors["firstName"] = "Please enter first name";
            formIsValid = false;
        }
        if (this.state.lastName === "" || this.state.lastName == null) {
            errors["lastName"] = "Please enter last name";
            formIsValid = false;
        }
        // if (this.state.emailId === "" || this.state.emailId == null) {
        //     errors["email"] = "Please enter valid email address";
        //     formIsValid = false;
        // } else if (this.state.emailId !== "undefined") {
        //     let lastAtPos = this.state.emailId.lastIndexOf('@');
        //     let lastDotPos = this.state.emailId.lastIndexOf('.');
        //     if (!(lastAtPos < lastDotPos && lastAtPos > 0 && this.state.emailId.indexOf('@@') === -1
        //         && lastDotPos > 2 && (this.state.emailId.length - lastDotPos) > 2)) {
        //         formIsValid = false;
        //         errors["email"] = "Please enter valid email address";
        //     }
        // }
        if (this.state.addressLine1 === "" || this.state.addressLine1 == null) {
            errors["addressline1"] = "Please enter address line 1";
            formIsValid = false;
        }
        if (this.state.pinCode === '' || this.state.pinCode === null) {
            errors["pinCode"] = "Please enter pin code";
            formIsValid = false;
        } 
        else if (this.state.pinCode.length !== 6) {
            errors["pinCode"] = "Pin code must be 6 digits";
            formIsValid = false;
        }
        if (this.state.dob === "" || this.state.dob === null) {
            errors["dob"] = "Date of birth cannot be empty";
            formIsValid = false;
        }
        if (this.state.genderMstDto === null || this.state.genderMstDto.genderId === '' || this.state.genderMstDto.genderId === null) {
            errors["gender"] = "Please select gender";
            formIsValid = false;
        }
        // if (this.state.height === '' || this.state.height === null) {
        //     errors["height"] = "Please enter height";
        //     formIsValid = false;
        // }
        // else if (this.state.height.toString().length > 3) { 
        //     errors["height"] = "Height must be 3 digits or less";
        //     formIsValid = false;
        // }
        // if (this.state.weight === '' || this.state.weight === null) {
        //     errors["weight"] = "Please enter weight";
        //     formIsValid = false;
        // }
        if (this.state.phoneNumber1 === "" || this.state.phoneNumber1 === null) {
            errors["phoneNumber1"] = "Contact no cannot be empty";
            formIsValid = false;
        }
        if (this.state.phoneNumber1 !== "" && this.state.phoneNumber1 !== null) {
            let num = this.state.phoneNumber1;
            if (num.length > 10 || num.length < 10) {
                errors["phoneNumber1"] = "Contact no must be 10 digits";
                formIsValid = false;
            }
        }
        if (this.state.instituteDto === null || this.state.instituteDto.instituteId === null || this.state.instituteDto.instituteId === '') {
            errors["institute"] = "Please select institute";
            formIsValid = false;
        }
        if (this.state.countryDto === null || this.state.countryDto.countryId === null) {
            errors["country"] = "Please select a country Code";
            formIsValid = false;
        }
                // Add new validations for country, state and city
    if (!this.state.selectedNewCountry.countryId) {
        errors["newCountry"] = "Please select country name";
        formIsValid = false;
    }

    // For state validation, check if country is selected first
    if (!this.state.selectedNewState.stateId) {
        if (!this.state.selectedNewCountry.countryId) {
            errors["newState"] = "Please select country name first";
        } else {
            errors["newState"] = "Please select state name";
        }
        formIsValid = false;
    }

    // For city validation, check if state is selected first
    if (!this.state.selectedNewCity.cityId) {
        if (!this.state.selectedNewState.stateId) {
            errors["newCity"] = "Please select state name first";
        } else {
            errors["newCity"] = "Please select city name";
        }
        formIsValid = false;
    }

     // New validations for patient type
     if (this.state.patientType === "DEFAULT" || this.state.patientType === null || this.state.patientType === "") {
        errors["patientType"] = "Please select patient type";
        formIsValid = false;
    }
    
    // Validation for Primary Consultant
    if (this.state.primaryConsultant === "" || this.state.primaryConsultant === null) {
        errors["primaryConsultant"] = "Please enter primary consultant";
        formIsValid = false;
    }
    
    // Emergency contact person validation
    if (this.state.emergencyContactPerson === "" || this.state.emergencyContactPerson === null) {
        errors["emergencyContactPerson"] = "Please enter emergency contact person";
        formIsValid = false;
    }
    
    // Emergency contact relation validation
    if (this.state.emergencyContactRelation === "" || this.state.emergencyContactRelation === null) {
        errors["emergencyContactRelation"] = "Please select emergency contact relation";
        formIsValid = false;
    }
    
    // Emergency contact number validation
    if (this.state.emergencyMobileNumber === "" || this.state.emergencyMobileNumber === null) {
        errors["emergencyMobileNumber"] = "Emergency contact number cannot be empty";
        formIsValid = false;
    } else if (this.state.emergencyMobileNumber.length !== 10) {
        errors["emergencyMobileNumber"] = "Emergency contact number must be 10 digits";
        formIsValid = false;
    }
    
    // Blood group validation
    if (this.state.bloodGroup === "DEFAULT" || this.state.bloodGroup === null || this.state.bloodGroup === "") {
        errors["bloodGroup"] = "Please select blood group";
        formIsValid = false;
    }

     // Add this to your existing validateGeneralInfo function

// Validation for referring physician phone number
if (this.state.referringPhysicianNumber) {
    // If provided, ensure it's a valid format (numbers only)
    const phoneRegex = /^\d+$/;
    if (!phoneRegex.test(this.state.referringPhysicianNumber)) {
      errors["referringPhysicianNumber"] = "Referring physician number should contain only digits";
      formIsValid = false;
    } else if (this.state.referringPhysicianNumber.length > 10) {
      errors["referringPhysicianNumber"] = "Referring physician number cannot exceed 10 digits";
      formIsValid = false;
    }
  }
  
  // Update the emergency contact and telephone validation to match the pattern
  // Emergency contact number validation
  if (this.state.emergencyMobileNumber === "" || this.state.emergencyMobileNumber === null) {
    errors["emergencyMobileNumber"] = "Emergency contact number cannot be empty";
    formIsValid = false;
  } else if (this.state.emergencyMobileNumber.length !== 10) {
    errors["emergencyMobileNumber"] = "Emergency contact number must be 10 digits";
    formIsValid = false;
  }
  
  // Validation for telephone number
  if (this.state.telephoneNumber) {
    // If provided, ensure it's a valid format (numbers only)
    const phoneRegex = /^\d+$/;
    if (!phoneRegex.test(this.state.telephoneNumber)) {
      errors["telephoneNumber"] = "Telephone number should contain only digits";
      formIsValid = false;
    } else if (this.state.telephoneNumber.length > 10) {
      errors["telephoneNumber"] = "Telephone number cannot exceed 10 digits";
      formIsValid = false;
    }
  }
    
    // Validation for referring physician phone number
    if (this.state.selectedReferralSource === 'Physician/Doctor' || this.state.selectedReferralSource === 'Hospital') {
        if (this.state.referringPhysicianNumber) {
            const phoneRegex = /^\d+$/;
            if (!phoneRegex.test(this.state.referringPhysicianNumber)) {
                errors["referringPhysicianNumber"] = "Physician phone number should contain only digits";
                formIsValid = false;
            }
        }
    }

    // Update the patientRegErrors state with new errors
    this.setState({ 
        patientRegErrors: {
            ...errors,
            newCountry: errors["newCountry"] || "",
            newState: errors["newState"] || "",
            newCity: errors["newCity"] || ""
        } 
    });
        this.setState({ patientRegErrors: errors });
        return formIsValid;
    }
    validateProfessionalInfo = () => {
        let formIsValid = true;
        let errors = {};
        // if (this.state.anyOngoingTreatment === null || this.state.anyOngoingTreatment === "") {
        //     errors["anyOngoingTreatment"] = "Please select any ongoing treatment";
        //     formIsValid = false;
        // }
        this.setState({ patientRegErrors: errors });
        return formIsValid;
    }
    setComorbidities(value) {
        this.setState({ patientComorbidities: value });
        let tempValue = JSON.stringify(value);
        if (tempValue !== null && tempValue !== '[]') {
            let jsonValue = JSON.parse(tempValue);
            let flag = false;
            jsonValue.map((item) => {
                if (item.name === 'Others- Specify' || item.name === 'Other commorbities, please specify') {
                    flag = true;
                }
            });
            if(flag){
                this.setState({ isCommorbitiesSelected: true });
            }else{
                this.setState({ isCommorbitiesSelected: false });
            }
        }else{
            this.setState({ isCommorbitiesSelected: false });
        }
    }
    setPatientAllergies(value) {
        this.setState({ patientAllergies: value });
        let tempValue = JSON.stringify(value);
        if (tempValue !== null && tempValue !== '[]') {
            let jsonValue = JSON.parse(tempValue);
            let flag = false;
            jsonValue.map((item) => {
                if (item.name === 'Other chemotherapy allergies, please specify' || item.name === 'Other Allergies, please specify') {
                    flag = true;
                }
            });
            if(flag){
                this.setState({ isAllergiesSelected: true });
            }else{
                this.setState({ isAllergiesSelected: false });
            }
        }else{
            this.setState({ isAllergiesSelected: false });
        }
    }
    setComorbiditiesMedicine(value) {
        this.setState({ patientComorbMed: value });
    }

    checkDoctorInstituteAssociation(){
        let userId = localStorage.getItem('userId');
        return fetch(C.getUrl() + `/institute/checkDoctorInstituteAssociation/${userId}`)
        .then(res => res.json())
        .then(res => {
            let resObj = res;
            let msg = resObj.message
            if(resObj.statusCode == '200'){
                this.setState({ checkDocInstAssociation : true});
            }else{
                this.setState({ checkDocInstAssociation : false});
                //swal({ title: "Warning!", text: msg, icon: "warning", buttons: "OK", timer: false });
                this.setState({ show: false });
            }
            //console.table(arr);
        })
        .catch(err => {
            swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
        });
    }

    showPatientDialog() {
        let data = JSON.parse(localStorage.getItem('userRoleDto'));
        let roleIdFromCache = data.roleId;
        if(roleIdFromCache !== 3){
            this.checkDoctorInstituteAssociation();
        }else{
            this.setState({ checkDocInstAssociation : true});
        }
        setTimeout(() => {
            if(this.state.checkDocInstAssociation){
                this.resetRegistrationForm();
                // Clear age-related fields here
                this.setState({
                    ageYears: '',
                    ageMonths: '',
                    ageDays: '',
                    dob: null, // Reset the date of birth
                });
                // Reset form tabs to show first step
                const nextTab = document.getElementById("nextTab");
                const currentTab = document.getElementById("nextTab1");
                if (nextTab && currentTab) {
                    nextTab.style.display = "none";
                    currentTab.style.display = "block";
                }
                this.getAllInstitute();
                this.getAllAllergies();
                this.getAllComorbidites();
                this.getAllUnits();
                this.getAllGender();
                this.getAllMedicines();
                this.getPatientDoc();
                this.getallCountries();
                //console.log('--ROLE ID ON PATIENT DIALOG : ' + roleIdFromCache)
                if (roleIdFromCache === 3) {
                    this.getAssociatedDocList();
                    this.setState({ show: true, isHospitalStaff: true, isAssociatedDocSelected: false });
                } else {
                    this.setState({ show: true });
                }
            }
        }, 200)
    }

    getCities() {
        return fetch(C.getUrl() + '/cityMaster/getallCities')
            .then(res => res.json())
            .then(data => {
                const cityArr = JSON.parse(data.message);
                this.setState({ cityArr });
            })
            .catch(err => console.error('Error fetching cities:', err));
    }
    
    getStates() {
        return fetch(C.getUrl() + '/stateMaster/getallStates')
            .then(res => res.json())
            .then(data => {
                const stateArr = JSON.parse(data.message);
                this.setState({ stateArr });
            })
            .catch(err => console.error('Error fetching states:', err));
    }

    resetRegistrationForm() {
        this.setState({ registrationDate: null, firstName: '', middleName: '', lastName: '', emailId: '', dob: '',ageYears: '', ageMonths: '', ageDays: '', genderMstDto: { genderId: '' },
                        countryDto: { countryId: null, countryCode: '' }, phoneNumber1: '', doctor: { userId: '', firstName: '', lastName: '', username: '', roleName: '' },
                        instituteDto: { instituteId: null, instituteName: '' }, height: null, heightUnit: { unitId: null, unitName: '' }, weight: null, 
                        weightUnit: { unitId: null, unitName: '' }, patientComorbidities: [], patientAllergies: [], anyOngoingTreatment: null, patientComorbMed: [], patientRegErrors: [],addressLine1: '',addressLine2: '', pinCode: this.state.pinCode, countryName:'' });
    }
    getPatientDoc() {
        if (localStorage.getItem("userRoleDto") !== null && localStorage.getItem("userRoleDto") !== ''
            && localStorage.getItem("userId") !== null && localStorage.getItem("userId") !== '') {
            let userRoleDto = JSON.parse(localStorage.getItem("userRoleDto"));
            let roleName = userRoleDto.roleName;
            if (roleName === 'Doctor') {
                let patientDoctor = {
                    userId: JSON.parse(localStorage.getItem("userId")),
                    firstName: localStorage.getItem("firstName"),
                    lastName: localStorage.getItem("lastName"),
                    roleName: roleName
                }
                this.setState({ doctor: patientDoctor });
            } else if (localStorage.getItem("associatedDocDto") !== null && localStorage.getItem("associatedDocDto") !== '') {
                let associateDocDto = JSON.parse(localStorage.getItem("associatedDocDto"));
                let patientDoctor = {
                    userId: JSON.parse(associateDocDto.userId),
                    firstName: associateDocDto.firstName,
                    lastName: associateDocDto.lastName,
                    roleName: roleName
                }
                this.setState({ doctor: patientDoctor });
            }
        }
    }

    savePatientDetial(event) {
        let isThisValidForm = false;
        if (this.validateGeneralInfo() && this.validateProfessionalInfo() && this.validateNewLocationFields()) {
            isThisValidForm = true;
        }
        var patientComorData = [];
        if (this.state.patientComorbidities !== null && this.state.patientComorbidities.size !== 0) {
            this.state.patientComorbidities.forEach(function (obj) {
                let datas = {
                    comorbiditiesDto: {
                        comorbiditiesId: obj.id, comorbiditiesName: obj.name
                    }
                }
                patientComorData.push(datas);
            });
        }
        var patientAllergiesData = [];
        if (this.state.patientAllergies !== null && this.state.patientAllergies.size !== 0) {
            this.state.patientAllergies.forEach(function (obj) {
                let data = {
                    allergiesMstDTO: {
                        allergiesId: obj.id, allergiesName: obj.name
                    }
                }
                patientAllergiesData.push(data);
            });
        }
        var patientComorMedData = [];
        if (this.state.patientComorbMed !== null && this.state.patientComorbMed.size !== 0) {
            this.state.patientComorbMed.forEach(function (obj) {
                let data = {
                    medicineMasterDto: {
                        medicineId: obj.id, medicineName: obj.name
                    }
                }
                patientComorMedData.push(data);
            });
        }
        var patientRegistrationObj = {
            registrationDate: this.state.registrationDate,
            firstName: this.state.firstName,
            middleName: this.state.middleName,
            lastName: this.state.lastName,
            emailId: this.state.emailId,
            addressLine1: this.state.addressLine1,
            addressLine2: this.state.addressLine2,
            pinCode: this.state.pinCode,          
            cityCode: this.state.cityCode,
            stateName: this.state.stateName,
            countryName: this.state.countryName,
            category: this.state.category,
            company: this.state.company,
            tarrif: this.state.tarrif,
            payType: this.state.payType,
            status: this.state.status,
            dob: this.state.dob,
            genderMstDto: {
                genderId: this.state.genderMstDto.genderId,
            },
            countryDto: {
                countryId: this.state.countryDto.countryId,
                countryCode: this.state.countryDto.countryCode
            },
            phoneNumber1: this.state.phoneNumber1,
            doctor: {
                userId: this.state.doctor.userId,
                firstName: this.state.doctor.firstName,
                lastName: this.state.doctor.lastName,
                username: '',
                userRoleDto: {
                    roleName: this.state.doctor.roleName
                }
            },
            instituteDto: {
                instituteId: this.state.instituteDto.instituteId,
                instituteName: this.state.instituteDto.instituteName
            },
            // height: parseFloat(this.state.height),
            // heightUnitDto: { unitId: this.state.heightUnit.unitId, unitName: this.state.heightUnit.unitName },
            // weight: parseFloat(this.state.weight),
            // weightUnitDto: { unitId: this.state.weightUnit.unitId, unitName: this.state.weightUnit.unitName },
            height: this.state.height ? parseFloat(this.state.height) : 1,
            heightUnitDto: { 
              unitId: this.state.heightUnit ? this.state.heightUnit.unitId : 1, 
              unitName: this.state.heightUnit ? this.state.heightUnit.unitName : 'cm' 
            },
            
            // For weight, set default weight value and unit ID 1 if not provided
            weight: this.state.weight ? parseFloat(this.state.weight) : 1,
            weightUnitDto: { 
              unitId: this.state.weightUnit ? this.state.weightUnit.unitId : 1, 
              unitName: this.state.weightUnit ? this.state.weightUnit.unitName : 'KG' 
            },
         
            patientComorbidities: patientComorData,
            patientAllergies: patientAllergiesData,
            onGoingTreatment: this.state.anyOngoingTreatment,
            otherOngoingTreatment: this.state.isOngoingTreatmentSelected ? this.state.otherOngoingTreatment : '',
            patientComorbiditiesMedicines: patientComorMedData,
            allergies: this.state.allergies,
            otherComorbidities: this.state.otherComorbidities,
            profilePictureName: this.state.profilePictureName1,
            profilePictureData: this.state.profilePictureData1,




             // height: parseFloat(this.state.height),
            // heightUnitDto: { unitId: this.state.heightUnit.unitId, unitName: this.state.heightUnit.unitName },
            // weight: parseFloat(this.state.weight),
            // weightUnitDto: { unitId: this.state.weightUnit.unitId, unitName: this.state.weightUnit.unitName },
           // For height, set default height value and unit ID 1 if not provided
      height: this.state.height ? parseFloat(this.state.height) : 1,
      heightUnitDto: { 
        unitId: this.state.heightUnit ? this.state.heightUnit.unitId : 1, 
        unitName: this.state.heightUnit ? this.state.heightUnit.unitName : 'cm' 
      },
      
      // For weight, set default weight value and unit ID 1 if not provided
      weight: this.state.weight ? parseFloat(this.state.weight) : 1,
      weightUnitDto: { 
        unitId: this.state.weightUnit ? this.state.weightUnit.unitId : 1, 
        unitName: this.state.weightUnit ? this.state.weightUnit.unitName : 'KG' 
      },
            patientComorbidities: patientComorData,
            patientAllergies: patientAllergiesData,
            onGoingTreatment: this.state.anyOngoingTreatment,
            otherOngoingTreatment: this.state.isOngoingTreatmentSelected ? this.state.otherOngoingTreatment : '',
            patientComorbiditiesMedicines: patientComorMedData,
            allergies: this.state.allergies,
            otherComorbidities: this.state.otherComorbidities,
            profilePictureName: this.state.profilePictureName1,
            profilePictureData: this.state.profilePictureData1,

            // New fields for the payload
            maritalStatus: this.state.maritalStatus,
        bloodGroup: this.state.bloodGroup,
        religion: this.state.religion,
        education: this.state.education,
        occupation: this.state.occupation,
        id_proof_type: this.state.idProofType,
        id_proof_number: this.state.idProofNumber,
        emergency_contact_person: this.state.emergencyContactPerson,
        emergency_mobile_number: this.state.emergencyMobileNumber ? parseInt(this.state.emergencyMobileNumber, 10) : null,
        emergency_landline_number: this.state.emergencyLandlineNumber ? parseInt(this.state.emergencyLandlineNumber, 10) : null,
        emergency_mobile_type: this.state.emergencyMobileType,
        emergency_landline_type: this.state.emergencyLandlineType,
        emergency_contact_relation: this.state.emergencyContactRelation,
        primary_consultant: this.state.primaryConsultant,
        patient_type: this.state.patientType,
        telphoneNo: this.state.telephoneNumber,
        
        // Current address fields
         // Fixed current address fields in savePatientDetial method
         stateAddress1: this.state.currentAddressline1,
         stateAddress2: this.state.currentAddressLine2,
         statePincode: this.state.currentPinCode,
         stateCity: this.state.selectedCurrentCity.cityCode,
         stateCountry: this.state.selectedCurrentCountry.countryName,
         currentContryID: this.state.selectedCurrentCountry.countryId,
         stateCurrent: this.state.selectedCurrentState.stateName,

   // Referral information 
   referralSource: this.state.referralSource,
   referralHospital: this.state.referringHospital || "",
   referral_Detail: this.state.referralDetails || "",  // Match exact DTO property
   referring_Physician: this.state.referringPhysician || "",  // Exact match for DTO
   referring_Phy_Num: this.state.referringPhysicianNumber || ""  // Exact match for DTOperty

        }
        console.log('--- REGITER PATIENT FORM : ' + JSON.stringify(patientRegistrationObj));
        if (isThisValidForm) {
            return fetch(C.getUrl() + '/userCase/registerPatient', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(patientRegistrationObj),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    swal({ title: "Warning!",  text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
                } else {
                    this.setState({show: false});
                    swal({ title: "Patient Case created successfully!", icon: "success", buttons: false, timer: 2000, });
                    //this.setState({ saveLoader: false, successAlertshow: false })
                    window.location.reload(false);
                }
            })
            .catch(err => {
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
        }
    }


    // Add this method to validate current address fields
validateCurrentLocationFields = () => {
    let isValid = true;
    const { patientRegErrors } = this.state;
    
    // Skip validation if using permanent address
    if (this.state.sameAsPermanent) {
        return true;
    }
    
    // Validate current country
    if (!this.state.selectedCurrentCountry.countryId) {
        patientRegErrors["currentCountry"] = "Please select a country";
        isValid = false;
    } else {
        patientRegErrors["currentCountry"] = "";
    }
    
    // Validate current state
    if (this.state.selectedCurrentCountry.countryId && !this.state.selectedCurrentState.stateId) {
        patientRegErrors["currentState"] = "Please select a state";
        isValid = false;
    } else {
        patientRegErrors["currentState"] = "";
    }
    
    // Validate current city
    if (this.state.selectedCurrentState.stateId && !this.state.selectedCurrentCity.cityId) {
        patientRegErrors["currentCity"] = "Please select a city";
        isValid = false;
    } else {
        patientRegErrors["currentCity"] = "";
    }
    
    // Update state with errors
    this.setState({ patientRegErrors });
    return isValid;
}
     // Add this validation method to your component
     validateAgeInput = (value, field) => {
        if (field === 'ageYears') {
            // Limit to 2 digits and max value of 99
            if (value.length > 2) {
                return value.slice(0, 2);
            }
            if (parseInt(value) > 99) {
                return '99';
            }
        }
        return value;
    };

    // DOB value adapter for the shared PatientRegistrationForm DatePicker.
    // Dashboard stores dob as a raw moment, so it is passed through as-is.
    getDobPickerValue = (d) => d;

    // Commit a country/state/city pick coming from guided voice mode, reusing
    // the exact same handlers + search-term state as the manual dropdown onClick.
    handleVoiceCombo = (kind, item) => {
        const id = item ? item.id : "";
        const name = item ? item.name : "";
        if (kind === 'country') {
            this.handleNewCountryChange({ target: { value: id } });
            this.setState({ countrySearchTerm: name, isCountryDropdownOpen: false });
        } else if (kind === 'state') {
            this.handleNewStateChange({ target: { value: id } });
            this.setState({ stateSearchTerm: name, isStateDropdownOpen: false });
        } else if (kind === 'city') {
            this.handleNewCityChange({ target: { value: id } });
            this.setState({ citySearchTerm: name, isCityDropdownOpen: false });
        }
    };

// Modify your existing setDOB method to use clearAgeFields
    setDOB = (date) => {
        this.setState({ dob: date }, () => {
            if (date) {
                const today = moment();
                const birthDate = moment(date);
                const duration = moment.duration(today.diff(birthDate));
                
                this.setState({
                    ageYears: Math.floor(duration.asYears()),
                    ageMonths: Math.floor(duration.asMonths() % 12),
                    ageDays: Math.floor(duration.asDays() % 30)
                });
                if (this.props.onDOBChange) {
                    this.props.onDOBChange(date);
                }
            } else {
                this.clearAgeFields();
            }
        });
    };
    clearAgeFields = () => {
        this.setState({
            ageYears: '',
            ageMonths: '',
            ageDays: '',
            dob: null
        }, () => {
            // Notify parent about DOB being cleared
            if (this.props.onDOBChange) {
                this.props.onDOBChange(null);
            }
        });
    };
    // Modify the handleAgeChange method to include validation
    handleAgeChange = (field, value) => {
        // First validate the input
        const validatedValue = this.validateAgeInput(value, field);
        const numValue = validatedValue === '' ? '' : parseInt(validatedValue, 10);
        
        this.setState({ [field]: numValue }, () => {
            const { ageYears, ageMonths, ageDays } = this.state;
            
            // If years field is cleared, clear everything
            if (field === 'ageYears' && validatedValue === '') {
                this.clearAgeFields();
                return;
            }
            // Only calculate DOB if we have at least years
            if (ageYears !== '') {
                const today = moment();
                const calculatedDate = today
                    .subtract(ageYears || 0, 'years')
                    .subtract(ageMonths || 0, 'months')
                    .subtract(ageDays || 0, 'days')
                    .startOf('day');
                
                this.setState({ dob: calculatedDate }, () => {
                    if (this.props.onDOBChange) {
                        this.props.onDOBChange(calculatedDate);
                    }
                });
            }
        });
    };



    setSelectedDocData = (data) => {
        if (localStorage.getItem("userRoleDto") !== null && localStorage.getItem("userRoleDto") !== ''
            && localStorage.getItem("userId") !== null && localStorage.getItem("userId") !== '') {
            let userRoleDto = JSON.parse(localStorage.getItem("userRoleDto"));
            let name = userRoleDto.roleName;
            this.setState({
                doctor: {
                    userId: data.id,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    roleName: name
                },
                isAssociatedDocSelected: true,
            });
            this.getAllInstituteAssociated(data.id);
        }
    }

    getDashboardData(){
        let data = JSON.parse(localStorage.getItem('userRoleDto'));
        let roleIdFromCache = data.roleId;
        let url;
        if (roleIdFromCache === 3) {
            this.setState({ isHospitalStaff: true });
            url = C.getUrl() + '/login/getDashboardDataForHospitalStaff/' + this.state.userId;
        }else{
            url = C.getUrl() + '/login/getDashboardData/' + this.state.userId;
        }
        console.log('[DB] getDashboardData CALLED — url:', url);
        return fetch(url)
        .then(res => {
            console.log('[DB] getDashboardData HTTP status:', res.status);
            return res.json();
        })
        .then(res => {
            this.setState({isLoaded: true});
            let resObj = res;
            let data = JSON.parse(resObj.message);
            console.log('[DB] todaysAppointmentData count:', data.todaysAppointmentData?.length, '| entries:', JSON.stringify(data.todaysAppointmentData?.map(a => ({ patientID: a.patientID, name: a.name, caseID: a.caseID, chemoDate: a.chemoDate }))));
            this.setState({ myActiveCaseCount: data.myActiveCaseCount });
            this.setState({ availableStaffCount: data.availableStaffCount });
            this.setState({ appointmentsCount: data.appointmentsCount });
            this.setState({ todaysAppointmentData: data.todaysAppointmentData });
            this.setState({ upcomingAppointmentData: data.upcomingAppointmentData });
            //this.calculateChemoDateDetails(data.upcomingAppointmentData);
        })
        .catch(err => {
            console.log("Error : " + err);
        });
    }

    calculateChemoDateDetails = (upcomingAppointments) => {
        const details = {};

        upcomingAppointments.forEach(d => {
            const date = this.formatDateMMDDYY(d.chemoDate);
            if (!details[date]) {
                details[date] = { count: 0, patients: [] };
            }
            details[date].count += 1;
        });

        this.setState({ chemoDateDetails: details });
        //console.log("Chemo Date Details:", details);
    };

    handleDateClick = (date) => {
        const selectedDate = this.formatDateMMDDYY(date); // Normalize the date format
        this.setState({ selectedDate }, () => {
            this.filterAppointmentsByDate();
        });
    };

    filterAppointmentsByDate = () => {
        const { selectedDate, allAppointmentData } = this.state;
    
        if (selectedDate) {
            const filteredAppointments = allAppointmentData.filter(appointment =>
                this.formatDateMMDDYY(appointment.chemoDate) === selectedDate
            );
            this.setState({ filteredAppointments });
        } else {
            this.setState({ filteredAppointments: allAppointmentData });
        }
    };
    
    
    openPreviewModalHandler = () => {
        return fetch(C.getUrl() + '/login/getMedicalStaffData/' + this.state.userId)
        .then(res => res.json())
        .then(res => {
            let resObj = res;
            let error = resObj.subErrors;
            if (error !== 'undefined' && error !== null && error !== "") {
                alert(error);
            } else {
            let obj = resObj.message;
            if (obj === 'No record found.') {} 
            else {
                this.setState({ data: JSON.parse(resObj.message)})
                let tempData = JSON.parse(resObj.message);
                let medicalStaffdata = [];
                tempData.forEach(obj => {
                    let fileData = obj.profilePictureData;
                    let tempprofiledate;
                    if(obj.profilePictureData !== undefined && obj.profilePictureData !== null && obj.profilePictureData !== ''){
                        tempprofiledate = <Image src={fileData} className="rounded-circle w-32 mr-2" />;
                    }else{
                        tempprofiledate = <Image src={`${process.env.PUBLIC_URL}/img/profile-male.png`} className="rounded-circle w-32 mr-2" />;
                    }
                    let data = {
                        id : tempprofiledate,
                        name : obj.firstName +' '+ obj.lastName,
                        email : obj.username,
                        number : obj.phoneNumber,
                        date : obj.approvedDate,
                    }
                        medicalStaffdata.push(data);
                });
                this.setState({ medicalStaffdata: medicalStaffdata });
                this.setState({ previewModal: true });
                }
            }
        })
        .catch(err => {
            console.log("Error : " + err);
        });
    }
    closePreviewModalHandler = () => {
        this.setState({ previewModal: false });
        this.setState({ medicalStaffdata: [] });
    }
    showEventsModal() {
        this.setState({ addEventModal: true });
    }

    formatDateMMDDYY(date) {
        if (date !== undefined && date !== "") {
            const dateObj = new Date(date);
            const day = String(dateObj.getDate()).padStart(2, '0');
            const month = String(dateObj.getMonth() + 1).padStart(2, '0'); 
            const year = dateObj.getFullYear();
            return `${day}-${month}-${year}`;
        }
        return "";
    }
    getAllAppointmentData() {
        var userId = localStorage.getItem("userId");
        let data = JSON.parse(localStorage.getItem('userRoleDto'));
        let roleIdFromCache = data.roleId;
    
        let url;
        if (roleIdFromCache === 3) {
            this.setState({ isHospitalStaff: true });
            url = C.getUrl() + '/login/getAllAppointmentDataForHospitalStaff/' + userId;
        } else {
            url = C.getUrl() + '/login/getAllAppointmentData/' + userId;
        }
    
        return fetch(url)
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let error = resObj.subErrors;
    
                if (error !== 'undefined' && error !== null && error !== "") {
                    swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000 });
                } else {
                    let obj = resObj.message;
                    if (obj === 'No record found.') {
                        // No data found
                    } else {
                        let tempData = JSON.parse(resObj.message);
                        let allAppointmentData = tempData.map(obj => ({
                            name: obj.firstName + ' ' + obj.lastName,
                            patientID: obj.patientID,
                            caseID: obj.caseId,
                            genderName: obj.genderMstDto.genderName,
                            phoneNumber: obj.phoneNumber1,
                            instituteName: obj.instituteDto.instituteName,
                            chemoDate:obj.chemoDate,
                            doctorName: obj.doctor ? obj.doctor.firstName + ' ' + obj.doctor.lastName : ''
                        }));
                        this.setState({ allAppointmentData });
                        this.calculateChemoDateDetails(allAppointmentData);
                        this.filterAppointmentsByDate();
                    }
                }
            })
            .catch(err => {
            });
    }
    
    profilePicHandler(e) {
        console.log('--> PROFILE PIC :: ' + e.target.files[0].name);
        console.log('--> PROFILE PIC [file type] :: ' + e.target.files[0].type);
        let file = e.target.files[0];
        let fileType = e.target.files[0].type;
        let validFileType = this.isValidFileType(fileType);
        
        if (file && validFileType) {
            const reader = new FileReader();
            reader.onload = this.fileReaderHandler;
            reader.readAsBinaryString(file);
            this.setState({
                profilePictureName1: e.target.files[0].name
            });
        }
    }

    fileReaderHandler(readerEvent) {
        let binaryString = readerEvent.target.result;
        let imageData = 'data:image/jpeg;base64,' + btoa(binaryString);
        console.log('--> BASE64 DATA : ' + imageData);
        this.setState({
            profilePictureData1: imageData
        });
    }

    isValidFileType(type) {
        switch (type) {
            case 'image/png':
            case 'image/jpeg':
            case 'image/jpg':
                return true;
            default:
                return false;
        }
    }
    

   // Add method to handle "Same as Permanent Address" checkbox
handleSameAddressChange(e) {
    const checked = e.target.checked;
    
    if (checked) {
        this.setState({
            sameAsPermanent: true,
            selectedCurrentCountry: this.state.selectedNewCountry,
            selectedCurrentState: this.state.selectedNewState,
            selectedCurrentCity: this.state.selectedNewCity,
            currentCountrySearchTerm: this.state.countrySearchTerm,
            currentStateSearchTerm: this.state.stateSearchTerm,
            currentCitySearchTerm: this.state.citySearchTerm
        });
        
        // Also update the filtered lists for current address
        this.setState({
            filteredCurrentCountryList: this.state.filteredCountryList,
            filteredCurrentStateList: this.state.filteredStateList,
            filteredCurrentCityList: this.state.filteredCityList
        });
    } else {
        this.setState({
            sameAsPermanent: false
        });
    }
}
// Update handleReferralSourceChange to correctly handle referralDetails
handleReferralSourceChange = (event) => {
    const selectedValue = event.target.value;
    
    if (selectedValue !== "DEFAULT") {
        this.setState({
            referralSource: selectedValue,
            selectedReferralSource: selectedValue,
            
            // Clear fields based on selection
            referringPhysician: (selectedValue === 'Physician/Doctor' || selectedValue === 'Hospital') 
                ? this.state.referringPhysician 
                : '',
            referringPhysicianNumber: (selectedValue === 'Physician/Doctor' || selectedValue === 'Hospital') 
                ? this.state.referringPhysicianNumber 
                : '',
            referralDetails: (selectedValue !== 'Physician/Doctor' && selectedValue !== 'Hospital') 
                ? this.state.referralDetails 
                : ''
        });
    }
};

// Integrated location search method
handleLocationSearch = (type, field, searchTerm) => {
    let sourceList = [];
    let targetStateField = '';
    
    if (type === 'permanent') {
        switch(field) {
            case 'country':
                sourceList = this.state.newCountryList;
                targetStateField = 'filteredCountryList';
                break;
            case 'state': 
                sourceList = this.state.newStateList;
                targetStateField = 'filteredStateList';
                break;
            case 'city':
                sourceList = this.state.newCityList;
                targetStateField = 'filteredCityList';
                break;
        }
    } else if (type === 'current') {
        switch(field) {
            case 'country':
                sourceList = this.state.currentCountryList;
                targetStateField = 'filteredCurrentCountryList';
                break;
            case 'state': 
                sourceList = this.state.currentStateList;
                targetStateField = 'filteredCurrentStateList';
                break;
            case 'city':
                sourceList = this.state.currentCityList;
                targetStateField = 'filteredCurrentCityList';
                break;
        }
    }
    
    if (sourceList && sourceList.length > 0) {
        const normalizedSearchTerm = searchTerm.toLowerCase();
        const filteredList = sourceList.filter(item => 
            item.name.toLowerCase().includes(normalizedSearchTerm)
        );
        
        const stateUpdate = {};
        stateUpdate[targetStateField] = filteredList;
        this.setState(stateUpdate);
    }
};
   
    render() {
        const { isHospitalStaff, isAssociatedDocSelected, associatedDocList,dob, ageYears, ageMonths, ageDays,isShowAssociatedWIthDoctor, isShowDocListModal,chemoDateDetails  } = this.state;
        const header = [{title: '#', prop: 'id'},{title: 'Full Name', prop: 'name', sortable: true, filterable: true},
                        {title: 'Chemo Date', prop: 'chemoDate', sortable: true},
                        {title: 'Email Id', prop: 'email', sortable: true},{title: 'Contact No.', prop: 'number', sortable: true},
                        {title: 'Date & Time of Registeration', prop: 'date'},];
        const customLabels = {show: 'Display', entries: 'rows', noResults: 'No records found'};
        const classes = {table: 'table-striped table-striped table-hover text-nowrap dataTable mt-4', thead: 'thead-light'};
        return (
            <div className="d-flex" id="wrapper">
                {<Side />}
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        { <Top/> }
                        <div className="container-fluid">
                            <div className="app-content">
                                <section className="section" id="accordion">
                                    <Row>
                                    <Col lg='12'>
    <div className="card shadow-none border-0 mb-0" style={{ backgroundColor: "#f2f8f1" }}>
        <div className="card-body card-link pt-0 pb-2 pl-2"> {/* Reduced padding */}
            <div className="d-flex align-items-center" style={{ gap: '10px' }}> {/* Reduced gap */}
                <h5 className="mb-0" style={{ whiteSpace: 'nowrap' }}>
                    <span className="font-weight-bold text-lg">Hello, Dr. {this.state.userdetail.firstName} {this.state.userdetail.lastName} !</span>
                </h5>
                
                {this.state.showMRNSearch && (
                    <div className="flex-grow-1 d-flex" style={{ maxWidth: '450px' }}> {/* Added maxWidth */}
                        <Form.Control
                            type="text"
                            placeholder="Enter MRN Number"
                            value={this.state.mrnNumber}
                            onChange={this.handleMRNChange}
                            maxLength={10}
                            disabled={this.state.searchLoading}
                            className="flex-grow-1 py-1" /* Reduced vertical padding */
                        />
                        <Button
                            variant="primary"
                            className="ml-2 py-1" /* Reduced vertical padding */
                            onClick={this.handleMRNSearch}
                            disabled={this.state.searchLoading || !this.state.mrnNumber}
                        >
                            {this.state.searchLoading ? (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            ) : (
                                'Get Patient Details'
                            )}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    </div>
</Col>
                                        <Col lg='9'>
                                            <Col lg='4' md='4' sm='4'>
                                                <div className="card" style={{ backgroundColor: "#c79e34" }}>
                                                    <div className="card-body card-link" data-toggle="collapse" href="#collapseDraft">
                                                        <Link className='no-underline' to="/Case">
                                                            <div className="row no-gutters align-items-center">
                                                                <div className="media-body">
                                                                    <h4 className="big">Active Cases</h4>
                                                                    <div className="fs-25 text-light font-weight-bold">{this.state.myActiveCaseCount}</div>
                                                                </div>
                                                                <FaHeartbeat className="display-3 text-white" />
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col lg='4' md='4' sm='4'>
                                                <div className="card" style={{ backgroundColor: "#42bbcf" }}>
                                                    <div className="card-body card-link" data-toggle="collapse" href="#collapseDraft">
                                                        <div className="row no-gutters align-items-center">
                                                            <div className="media-body">
                                                                <h4 className="big">Appointments</h4>
                                                                <div className="fs-25 text-light font-weight-bold">{this.state.appointmentsCount}</div>
                                                            </div>
                                                            <FaCalendarDay className="display-3 text-white" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                            {(() => {
                                                if (!isHospitalStaff) {
                                                    return (
                                                        <Col lg='4' md='4' sm='4'>
                                                            <div className="card" style={{ backgroundColor: "#31b492" }}>
                                                                <a onClick={() => this.openPreviewModalHandler()}>
                                                                    <div className="card-body card-link" data-toggle="collapse" href="#collapseDraft">
                                                                        <div className="row no-gutters align-items-center">
                                                                            <div className="media-body">
                                                                                <h4 className="big">Available Staff</h4>
                                                                                <div className="fs-25 text-light font-weight-bold">{this.state.availableStaffCount}</div>
                                                                            </div>
                                                                            <FaUserNurse className="display-3 text-white" />
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </Col>
                                                    )
                                                }
                                            })()}
                                            <Col lg='12'>
                                                <div id="collapseDraft" className="card border-0 pb-4 pt-4 pl-4 pr-4">
                                                    <Button className='text-primary newPatient font-w500 pull-right mb-4' onClick={this.showPatientDialog.bind(this)}><FaPlus className='mr-2 mb-1'/>New Patient</Button>
                                                    <Tabs defaultActiveKey="generalInfo" id="uncontrolled-tab-example">
                                                        <Tab eventKey="generalInfo" title="Today's Appointments">
                                                            <div className="card-body p-3">
                                                                <div className="demo-html">
                                                                    <div id="example_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                                                        <div className="row">
                                                                            <div className="col-sm-12 pl-0 pr-0">
                                                                                <Link className='text-primary font-w500 pull-right mb-4' to="/appointmentView">View All</Link>
                                                                                <table responsive="lg" id="example" className="table dataTable no-footer" role="grid" aria-describedby="example_info">
                                                                                    <thead className="thead-light">
                                                                                        <tr role="row">
                                                                                            <th aria-controls="example" colSpan="1">#</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Patient Name</th>
                                                                                            <th className="sorting" aria-controls="example" colSpan="1">Case ID</th>
                                                                                            <th className="sorting" aria-controls="example" colSpan="1">Gender</th>
                                                                                            <th className="sorting" aria-controls="example" colSpan="1">Contact No.</th>
                                                                                            <th className="sorting" aria-controls="example" colSpan="1">Hospital</th>
                                                                                            {(() => {
                                                                                                if (isHospitalStaff) {
                                                                                                    return (
                                                                                                        <th className="sorting" aria-controls="example" colSpan="1">Doctor Name</th>
                                                                                                    )
                                                                                                }
                                                                                            })()}
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {typeof this.state.todaysAppointmentData !== 'undefined' ?
                                                                                            this.state.todaysAppointmentData.map((d, idx) => (
                                                                                            <tr key={idx} role="row" className="odd">
                                                                                                <td><Image src={`${process.env.PUBLIC_URL}/img/profile-male.png`} className="rounded-circle w-32 mr-2" /></td>
                                                                                                <td><Link to={{ pathname: '/caseprofile', search: 'p=' + d.patientID }}>{d.firstName} {d.lastName} </Link></td>
                                                                                                <td>{d.caseId}</td>
                                                                                                <td>{d.genderMstDto.genderName}</td>
                                                                                                <td>{d.phoneNumber1}</td>
                                                                                                <td>{d.instituteDto.instituteName}</td>
                                                                                                {(() => {
                                                                                                    if (isHospitalStaff && d.doctor != undefined && d.doctor != null) {
                                                                                                        return (
                                                                                                            <td>{d.doctor.firstName} {d.doctor.lastName}</td>
                                                                                                        )
                                                                                                    }
                                                                                                })()}
                                                                                            </tr>
                                                                                        )) : 
                                                                                            <tr className="tbody-tr"><td className="tbody-td" colSpan="7" style={{ textAlign: "center" }}><Image src={`${process.env.PUBLIC_URL}/img/Norecords.png`} style={{width: "43%"}} /></td></tr>
                                                                                        }
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Tab>
                                                        
                                                        <Tab eventKey="AllAppointments" title="Upcoming Appointments">
                                                            <div className="card-body p-3" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                                <div className="demo-html">
                                                                    <div id="example_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                                                        <div className="row">
                                                                            <div className="col-sm-12 pl-0 pr-0">
                                                                                <Link className='text-primary font-w500 pull-right mb-4' to="/appointmentView">View All</Link>
                                                                                <table responsive="lg" id="example" className="table dataTable no-footer" role="grid" aria-describedby="example_info">
                                                                                    <thead className="thead-light">
                                                                                        <tr role="row">
                                                                                            <th aria-controls="example" colSpan="1">#</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Patient Name</th>
                                                                                            <th className="sorting" aria-controls="example" colSpan="1">Case ID</th>
                                                                                            <th className="sorting" aria-controls="example" colSpan="1">Gender</th>
                                                                                            <th className="sorting" aria-controls="example" colSpan="1">Contact No.</th>
                                                                                            <th className="sorting" aria-controls="example" colSpan="1">Hospital</th>
                                                                                            <th className="sorting" aria-controls="example" colSpan="1">Chemo Date</th>
                                                                                            {(() => {
                                                                                                if (isHospitalStaff) {
                                                                                                    return (
                                                                                                        <th className="sorting" aria-controls="example" colSpan="1">Doctor Name</th>
                                                                                                    )
                                                                                                }
                                                                                            })()}
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                    {this.state.filteredAppointments.length > 0 ? (
                                                                                        this.state.filteredAppointments
                                                                                        .sort((a, b) => new Date(a.chemoDate) - new Date(b.chemoDate))
                                                                                        .map((appointment, idx) => (
                                                                                            <tr key={idx} role="row" className="odd">
                                                                                                <td>
                                                                                                    <Image src={`${process.env.PUBLIC_URL}/img/profile-male.png`} className="rounded-circle w-32 mr-2" />
                                                                                                </td>
                                                                                                <td style={{ padding: '0', margin: '0', whiteSpace: 'normal', wordWrap: 'break-word', maxWidth: '150px' }}>
                                                                                                    <Link to={{ pathname: '/caseprofile', search: 'p=' + appointment.patientID }}>
                                                                                                        {appointment.name}
                                                                                                    </Link>
                                                                                                </td>
                                                                                                <td>{appointment.caseID}</td>
                                                                                                <td>{appointment.genderName}</td>
                                                                                                <td>{appointment.phoneNumber}</td>
                                                                                                <td>{appointment.instituteName}</td>
                                                                                                <td>{this.formatDateMMDDYY(appointment.chemoDate)}</td>
                                                                                                {(() => {
                                                                                                    if (this.state.isHospitalStaff && appointment.doctorName) {
                                                                                                        return (
                                                                                                            <td>{appointment.doctorName}</td>
                                                                                                        )
                                                                                                    }
                                                                                                })()}
                                                                                            </tr>
                                                                                        ))
                                                                                    ) : (
                                                                                        <tr className="tbody-tr">
                                                                                            <td className="tbody-td" colSpan="7" style={{ textAlign: "center" }}>
                                                                                                <Image src={`${process.env.PUBLIC_URL}/img/Norecords.png`} style={{ width: "43%" }} />
                                                                                            </td>
                                                                                        </tr>
                                                                                    )}
                                                                                </tbody>

                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Tab>
                                                    </Tabs>
                                                </div>
                                            </Col>
                                        </Col>
                                        <Col lg='3'>
                                            <Card className="border-0">
                                                <Card.Body className="border-0 pb-0">
                                                    <div className="calendar_plan">
                                                        <Calendar  
                                                        next2Label={false} 
                                                        prev2Label={false}
                                                        onClickDay={(value, event) => this.handleDateClick(value)} // Add onClickDay handler 
                                                        tileContent={({ date }) => {
                                                            const normalizedDate = this.formatDateMMDDYY(date);
                                                            const count = chemoDateDetails[normalizedDate]?.count || 0; 
    
                                                            return (
                                                                <div style={{ position: 'relative'}}>
                                                                    <Badge
                                                                        badgeContent={count}
                                                                        color="error" 
                                                                        overlap="rectangular"
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: 0,
                                                                            right: 0,
                                                                            transform: 'translate(50%, -50%)',
                                                                        }}
                                                                    />
                                                                </div >
                                                            );
                                                        }}
                                                        />
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                            <Card className="mb-0">
                                                <Card.Header className='output' style={{backgroundColor: 'rgb(247 247 247)'}}>
                                                    <h2 className="ce_title mb-0"><b>Upcoming Events</b></h2>
                                                    <button className="btn btn-light pull-right d-flex addEvents-btn p-0" style={{backgroundColor: '#f7f7f7'}} onClick={this.showEventsModal.bind(this)}>
                                                        <FaPlus size='1.5rem' />
                                                    </button>
                                                </Card.Header>
                                                <Card.Body className="border-0">
                                                    <div className="calendar_events pl-4 ml-2">
                                                        <div className="event_item">
                                                            <p className="calender_placeholder">No events schedules</p>
                                                        </div> 
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                   
                                </section>
                                <Modal show={this.state.addEventModal} animation={true} size="lg">
                                    <Modal.Header closeButton onClick={() => this.setState({ addEventModal: false })}>
                                        <Modal.Title><h3 className="fs-18 header_title mb-0 text-black">Create Event</h3></Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Container fluid>
                                            <Row>
                                                <Col lg='4'>
                                                    <Form.Group>
                                                        <Form.Label>Event Name</Form.Label>
                                                        <Form.Control type='text' placeholder='' name='registrationDate' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='4'>
                                                    <Form.Group>
                                                        <Form.Label>Event Description</Form.Label>
                                                        <Form.Control type='text' placeholder='' name='docName' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='4'>
                                                    <Form.Group>
                                                        <Form.Label>Event Date</Form.Label>
                                                        {/* <DatePicker
                                                            // selected={this.state.dob}
                                                            // onChange={date => this.setDOB(date)}
                                                            dateFormat="dd/MM/yyyy"
                                                            placeholderText="Date of Birth"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                        /> */}
                                                        <DatePicker
                                                            onChange={date => this.setDOB(date)}
                                                            placeholder="Date of Birth"
                                                            format={dateFormat}
                                                            className="full-width" />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='12'>
                                                    <div className="form-button text-right">
                                                        <Button className=" btn btn-info" style={{ fontSize: "14px" }}>Submit</Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </Modal.Body>
                                </Modal>
                                
                            </div>
                        </div>
                        <Modal id="" show={this.state.previewModal} animation={true} scrollable={true} size="lg">
                            <Modal.Header closeButton onClick={() => this.setState({ previewModal: false })}>
                                <Modal.Title><h3 className="fs-18 header_title mb-0 text-black">Available Staff</h3></Modal.Title>
                           </Modal.Header>
                            <Modal.Body>
                                <Container fluid>
                                    <Row>
                                        <Col lg='12' className="p-0">
                                            <CustomTable
                                                id="datatableProtocolList"
                                                tableHeaders={header}
                                                tableBody={this.state.medicalStaffdata} 
                                                rowsPerPage={10}
                                                //rowsPerPageOption={[5, 10, 15, 20]}
                                                initialSort={{ prop: 'id', isAscending: true }}
                                                labels={customLabels}
                                                classes={classes}
                                            />
                                        </Col>
                                    </Row>
                                </Container>
                            </Modal.Body>
                        </Modal>
                        <PatientRegistrationForm
                            ctx={this}
                            isHospitalStaff={isHospitalStaff}
                            isAssociatedDocSelected={isAssociatedDocSelected}
                            associatedDocList={associatedDocList}
                            dob={dob}
                            ageYears={ageYears}
                            ageMonths={ageMonths}
                            ageDays={ageDays}
                        />
                    </div>
                </div>
            </div>
        );
    }
  }
// }